<script src="../../http/axios.js"></script>
<template>
  <div style="height:100%">
    <div
      class="el-data-table xyj-table"
      id="tabledrag"
      @click.ctrl="showTable"
      v-show="!workFlowClientshow"
    >
      <el-row
        class="xyj-tooltip"
        type="flex"
        align="middle"
        justify="space-between"
        id="aaa"
      >
        <div class="xyj-operates">
          <el-form>
            <el-form-item>
              <Xyj-button
                style="padding: 7px;"
                v-if="hasExport"
                type="primary"
                :disabled="disabledExport"
                @click="onDefaultExport"
                :tableName="tableName"
                :label="$t('action.export')"
                text="导出"
              />
              <Xyj-button
                style="padding: 7px;"
                v-if="hasNew"
                type="primary"
                :disabled="disabledNew"
                @click="onDefaultNew($event)"
                :tableName="tableName"
                :label="$t('action.add')"
                text="新增"
              />
              <Xyj-button
                style="padding: 7px;"
                v-show="!batchDelete ? batchDelete : hasSelect && hasDelete"
                type="danger"
                :label="deleteText ? $t(deleteText) : $t('action.batchDelete')"
                text="批量删除"
                @click="onDefaultDelete($event, selected, 'many')"
                :tableName="tableName"
                :disabled="
                  single
                    ? !selected.length || selected.length > 1
                    : !selected.length || disabledNew
                "
              />
              <slot name="xyjcontainer"></slot>
            </el-form-item>
          </el-form>
        </div>
        <el-row type="flex" align="middle" justify="end">
          <div v-if="isToggle">
            <el-button-group>
              <el-button size="mini" @click="toggleFunc(ninetoggle)"
                ><i class="fa" :class="ninetoggle?'fa-th-large':'fa-list'" aria-hidden="true"></i
              ></el-button>
            </el-button-group>
          </div>
          <el-row
            type="flex"
            align="middle"
            justify="end"
            v-if="hasSearch
                ? getQuickSearch.length > 0 || !!$slots.search
                : hasSearch"
          >
            <!--搜索字段-->
            <el-form-renderer
              class="serachStyle"
              v-if="getQuickSearch.length > 0 || !!$slots.search"
              inline
              :content="getQuickSearch"
              :key="searchKey"
              ref="searchForm"
              @keyup.native="accountEnter($event)"
            >
              <!--@slot 额外的搜索内容, 当searchForm不满足需求时可以使用-->
              <slot name="search"></slot>
            </el-form-renderer>
            <el-form>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="search"
                  size="mini"
                  icon="el-icon-search"
                  circle
                  title="查询"
                >
                </el-button>
                <!-- <el-button @click="resetSearch" size="mini">重置</el-button> -->
                <el-button
                  style="padding: 7px;"
                  @click="searchTitledialogVisible = true"
                  size="mini"
                  icon="el-icon-zoom-in"
                  type="primary"
                  circle
                  title="高级查询"
                ></el-button>
              </el-form-item>
            </el-form>
          </el-row>
        </el-row>
      </el-row>
      <div class="getInvestInfo">
        <slot name="getInvestInfo"></slot>
      </div>

      <!--表格-->
      <el-table
        v-if="ninetoggle"
        ref="table"
        v-bind="getTableAttrs"
        :data="data"
        :row-style="showRow"
        @sort-change="fieldSort"
        element-loading-text="拼命加载中"
        v-loading="loading"
        size="mini"
        v-on="tableOns"
        highlight-current-row
        :row-key="getRowKeys"
        :expand-row-keys="expands"
        @header-dragend="headerDragend"
        @current-change="handleSelectionChange"
        @selection-change="mhandleSelectionChange"
        @select-all="onSelectAll"
        @row-click="RowClick"
        @row-dblclick="RowDblclick"
        @select="onSelect"
        class="tableMain"
        tooltip-effect="light"
      >
        <template v-if="isTree">
          <!--有多选-->
          <template v-if="hasSelect">
            <el-table-column
              key="selection-key"
              v-bind="getTableColumns[0]"
            ></el-table-column>
            <el-table-column key="tree-ctrl" v-bind="getTableColumns[1]">
              <template slot-scope="scope">
                <div v-if="isTree">
                  <span
                    v-for="space in scope.row._level"
                    class="ms-tree-space"
                    :key="space"
                  ></span>
                </div>
                <span
                  v-if="isTree && iconShow(scope.$index, scope.row)"
                  class="tree-ctrl"
                  @click="toggleExpanded(scope.$index)"
                >
                  <i v-if="!scope.row._expanded" class="el-icon-plus"></i>
                  <i v-else class="el-icon-minus"></i>
                </span>
                {{ scope.row[columns[1].prop] }}
              </template>
            </el-table-column>

            <el-table-column
              v-for="(col, n) in TableColumns.filter(
                (c, i) => i !== 0 && i !== 1
              )"
              :key="n"
              v-bind="col"
            >
            </el-table-column>
          </template>
          <!--无选择-->
          <template v-else>
            <!--展开这列, 丢失 el-table-column属性-->
            <el-table-column key="tree-ctrl" v-bind="getTableColumns[0]">
              <template slot-scope="scope">
                <div v-if="isTree">
                  <span
                    v-for="space in scope.row._level"
                    class="ms-tree-space"
                    :key="space"
                  ></span>
                </div>
                <span
                  v-if="isTree && iconShow(scope.$index, scope.row)"
                  class="tree-ctrl"
                  @click="toggleExpanded(scope.$index)"
                >
                  <i v-if="!scope.row._expanded" class="el-icon-plus"></i>
                  <i v-else class="el-icon-minus"></i>
                </span>
                {{ scope.row[TableColumns[0].prop] }}
              </template>
            </el-table-column>

            <el-table-column
              v-for="(col, j) in getTableColumns.filter((c, i) => i !== 0)"
              :key="j"
              v-bind="col"
            >
            </el-table-column>
          </template>
        </template>
        <!--非树-->
        <template v-else>
          <!-- table展开行 -->
          <el-table-column
            v-if="isExpand"
            type="expand"
            label
            show-overflow-tooltip
            width="50"
            fixed="left"
            align="center"
          >
            <template slot-scope="scope">
              <slot name="expandContent" :row="scope.row"></slot>
            </template>
          </el-table-column>
          <!--处理分页序号累加功能-->
          <el-table-column
            label="序号"
            show-overflow-tooltip
            width="50"
            fixed="left"
            align="center"
            v-if="hasSort"
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + (page - 1) * size + 1 }}</span>
            </template>
          </el-table-column>
          <!-- 选择列 -->
          <el-table-column
            v-if="
              getTableColumns.length > 0 &&
                getTableColumns.filter(x => x.type == 'selection').length > 0
            "
            v-bind="
              getTableColumns.length > 0
                ? getTableColumns.filter(x => x.type == 'selection')[0]
                : ''
            "
            :selectable="selectable"
            type="selection"
            key="12"
          ></el-table-column>
          <template v-for="item in getTableColumns">
            <!--处理多级表头 -->
            <xyj-multilevel-header @to-opere2dit="toopere2dit"
              v-if="item.children && item.children.length"
              v-bind:key="item.id"
              v-bind:column="item"
              v-bind:isSelfSort="isSelfSort"
              v-bind:hasOperEdit="hasOperEdit"
            ></xyj-multilevel-header>
            <el-table-column
              v-else-if="item.prop != 'select'"
              :key="item.id"
              v-bind="item"
              :sortable="
                item.sortType != 2 ? (isSelfSort ? true : 'custom') : false
              "
            >
              <template slot-scope="scope">
                <!-- <img
                  v-if="item.showType == 2"
                  :src="scope.row[item.prop]"
                  :style="{width:img.width,height:img.height}"
                  class="avatar"
                /> -->
                <viewer

                  :images="[scope.row[item.prop]]"
                  :style="{ width: img.width, height: img.height }"
                  v-if="item.showType == 2"
                >
                  <img
                    :src="scope.row[item.prop]"
                    :style="{ width: img.width, height: img.height }"
                    class="avatar"
                  />
                </viewer>
                <!-- 表格编辑列 ifEntryRequired 录入是否必填-->
                <!-- 时间搜索类型 date日期  singleDate日期时间 datePicker日期范围 年月month-->
                <div v-if="item.showType == 1 && hasOperEdit && ((onpeprop == item.prop && onpeid == (item.formatter?item.formatter(scope.row, null, scope.row.id):scope.row.id)) || (item.ifEntryRequired == 1 && (scope.row[item.prop] == '' || scope.row[item.prop] == null)))">
                  <span v-if="(isred || scope.row[item.prop] == '') && item.ifEntryRequired == 1" style="color: #ff0000;">*</span>
                  <el-date-picker v-if="item.fieldType == 'date'"
                    v-model="scope.row[item.prop]"
                    type="date" size="mini" :id="scope.row.id + item.prop"
                    placeholder="选择日期" value-format="yyyy-MM-dd" :clearable="item.ifEntryRequired == 1?false:true"
                    @focus="ToOperedit(scope.row[item.prop],scope.row,item,scope.index)"
                    @change="tochange"
                    >
                  </el-date-picker>
                  <el-date-picker v-else-if="item.fieldType == 'singleDate'"
                    v-model="scope.row[item.prop]"
                    type="datetime" size="mini" :id="scope.row.id + item.prop"
                    placeholder="日期时间" value-format="yyyy-MM-dd HH:mm:ss" :clearable="item.ifEntryRequired == 1?false:true"
                    @focus="ToOperedit(scope.row[item.prop],scope.row,item,scope.index)"
                    @change="tochange"
                    >
                  </el-date-picker>
                  <el-date-picker v-else-if="item.fieldType == 'datePicker'"
                    v-model="scope.row[item.prop]"
                    type="daterange" size="mini" :id="scope.row.id + item.prop"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="item.ifEntryRequired == 1?false:true"
                    @focus="ToOperedit(scope.row[item.prop],scope.row,item,scope.index)"
                    @change="tochange"
                    >
                  </el-date-picker>
                  <el-date-picker v-else-if="item.fieldType == 'month'"
                    v-model="scope.row[item.prop]"
                    type="month" size="mini" :id="scope.row.id + item.prop"
                    placeholder="选择年月" value-format="yyyy-MM" :clearable="item.ifEntryRequired == 1?false:true"
                    @focus="ToOperedit(scope.row[item.prop],scope.row,item,scope.index)"
                    @change="tochange"
                    >
                  </el-date-picker>
                  <el-select v-else-if="item.fieldType == 'select'" v-model="scope.row[item.prop]" placeholder="请选择" @focus="ToOperedit(scope.row[item.prop],scope.row,item,scope.index)"
                      @change="tochange" size="mini">
                    <el-option
                      v-for="ctem in numTapo(item)"
                      :key="ctem.value"
                      :label="ctem.label"
                      :value="ctem.value"
                      >
                    </el-option>
                  </el-select>
                  <el-input v-else style="width: 100%;" :id="scope.row.id + item.prop"
					            placeholder="可编辑"
                      size="mini"
                      v-model="scope.row[item.prop]"
                      @focus="ToOperedit(scope.row[item.prop],scope.row,item,scope.index)"
                      @blur="onblur(scope.row[item.prop])">
                  </el-input>
                </div>
                <div v-else-if="item.showType == 1 && item.isEdit" @dblclick.stop="OnOperedit(scope.row,item,2,scope.index)">
                  <span
                      v-html="(item.formatter? item.formatter(scope.row, null, scope.row[item.prop]): scope.row[item.prop])||(hasOperEdit?putedit:'')"
                      @click.stop="OnOperedit(scope.row,item,1,scope.index)"
                    ></span>
                </div>
                <div v-else-if="item.showType == 1">
                  <span
                      v-html="item.formatter? item.formatter(scope.row, null, scope.row[item.prop]): scope.row[item.prop]"
                    ></span>
                </div>
                
                <el-progress
                  v-if="item.showType == 4"
                  :text-inside="true"
                  :stroke-width="18"
                  :percentage="scope.row[item.prop]"
                ></el-progress>
                <!-- 自定义单元格内容 -->
                <!-- row:表格行数据,cellObj:表头数据 -->
                <slot
                  v-if="item.showType == 5"
                  name="cellcontent"
                  :row="scope.row"
                  :cellObj="item"
                  :index="scope.$index"
                ></slot>
              </template>
            </el-table-column>
          </template>
        </template>
        
        <!--默认操作列-->
        <el-table-column
          :label="operationLabel"
          v-if="hasOperation && workflowShowOperation"
          v-bind="operationAttrs"
          fixed="left"
          align="center"
        >
          <template slot-scope="scope">
            <el-row type="flex" justify="center">
              <Xyj-button
                style="padding: 7px;"
                v-if="isTree && hasNew"
                type="primary"
                :label="$t('action.add')"
                text="新增"
                :disabled="disabledNew"
                @click="onDefaultNew($event, scope.row)"
              />
              <Xyj-button
                style="padding: 7px;"
                v-if="hasEdit"
                :label="$t('action.edit')"
                text="编辑"
                :disabled="
                  scope.row.isShow
                    ? scope.row.isShow
                    : disabledEdit || disabledNew
                "
                @click="onDefaultEdit($event, scope.row)"
                :tableName="tableName"
              />
              <Xyj-button
                style="padding: 7px;"
                type="primary"
                v-if="isWorkflow"
                :label="$t('workflow.agree')"
                text="审批"
                :disabled="
                  workflow
                    ? scope.row[workflow] == 3
                    : scope.row['applyState'] == 3
                "
                @click="onDefaultworkflow($event, scope.row)"
                :tableName="tableName"
              />
              <Xyj-button
                style="padding: 7px;"
                v-if="hasView"
                type="info"
                :label="$t('action.search')"
                text="查询"
                :tableName="tableName"
                :disabled="disabledView"
                @click="onDefaultView($event, scope.row)"
              />
              <!-- 停用启用 -->
              <Xyj-button
                style="padding: 7px;"
                v-if="hasDisable"
                :type="
                  scope.row[ifDisabled] == defaultDisabledValue
                    ? 'info'
                    : 'primary'
                "
                :label="
                  scope.row[ifDisabled] == defaultDisabledValue
                    ? $t('action.disable')
                    : $t('action.enable')
                "
                :text="
                  scope.row[ifDisabled] == defaultDisabledValue
                    ? '停用'
                    : '启用'
                "
                :tableName="tableName"
                @click="onDefaultDisabled($event, scope.row)"
              />

              <Xyj-button
                style="padding: 7px;"
                v-if="btn.show ? btn.show(scope.row) : true"
                v-for="(btn, i) in extraButtons"
                :label="$t(btn.label)"
                :type="btn.type"
                :disabled="btn.disabled ? btn.disabled(scope.row) : false"
                v-bind="btn"
                @click="
                  onCustomButtonsClick(
                    $event,
                    btn.atClick,
                    scope.row,
                    scope.$index
                  )
                "
                :key="i"
                size="mini"
                :loading="customButtonsLoading"
                :text="btn.text"
                >{{ btn.text }}</Xyj-button
              >
              <!-- 用于自定义按钮状态切换 -->
              <Xyj-button
                style="padding: 7px;"
                v-if="
                  scope.row[btn.prop] == btn.value
                    ? false
                    : btn.show
                    ? btn.show(scope.row)
                    : true
                "
                v-for="(btn, i) in changeBtns"
                :label="$t(btn.label)"
                :type="btn.type"
                :disabled="btn.disabled ? btn.disabled(scope.row) : false"
                v-bind="btn"
                @click="onCustomButtonsClick($event, btn.atClick, scope.row)"
                :key="i"
                size="mini"
                :loading="customButtonsLoading"
                :text="btn.text"
                >{{ btn.text }}</Xyj-button
              >

              <Xyj-button
                style="padding: 7px;"
                v-if="!hasSelect && hasDelete && canDelete(scope.row)"
                type="danger"
                :label="deleteText1 ? $t(deleteText1) : $t('action.delete')"
                text="删除"
                :tableName="tableName"
                :disabled="
                  scope.row.isShow
                    ? scope.row.isShow
                    : disabledDelete || disabledNew
                "
                @click="onDefaultDelete($event, scope.row, 'single')"
              />
              <!--@slot 自定义操作列, 当 extraButtons 不满足需求时可以使用 -->
              <slot
                name="otherOperations"
                :list="scope.row"
                :index="scope.$index"
              ></slot>
            </el-row>
          </template>
        </el-table-column>
        <!--@slot 自定义操作列, 当extraButtons不满足需求时可以使用 -->
        <slot></slot>
        <!-- 暂无数据显示内容 -->
        <template slot="empty">
          <div style="width: 100%">
            <img
              style="width: 224px; height: 131px"
              src="../../../static/img/tableempty.png"
            />
            <span style="display: block; line-height: 30px">暂无数据</span>
          </div>
        </template>
      </el-table>
      <div v-else :style="[nineStyle.nineAll]" style="overflow: auto;">
        <div v-if="isnineContent" class="infinite-list-wrapper">
          <div
            class="list"
            v-infinite-scroll="load"
            infinite-scroll-disabled="scrolldisabled"
          >
            <!-- tableData:表格数据,tableColumns:表头数据 -->
            <slot
              class="list-item"
              name="toggleContent"
              :data="{ tableData: togoData, tableColumns: getTableColumns }"
            ></slot>
          </div>
          <!-- <p v-if="togloading">加载中...</p>
          <p v-if="noMore">没有更多了</p> -->
        </div>
        <!-- 四宫格 start -->
        <div v-else-if="isSigongGrid">
          <div class="custom-carousel"
              ref="carouselContainer"
              @mousedown="handleMouseDown"
              @mousemove="handleMouseMove"
              @mouseup="handleMouseUp"
              @mouseleave="handleMouseUp">
            <el-carousel :autoplay="false" ref="carousel"  height="720px" indicator-position="none" @change="oncarChange" :initial-index="pageNum">
              <el-carousel-item v-for="ctem in newData" :key="ctem.id">
                <div class="clearfix-cc" @click.stop="">
                  <viewer ref="viewer" :images="srcList">
                  <div v-for="(item,i) in ctem" :key="i" style="float: left;width:49%;">
                    <img :style="(i % 2) == 0?'':'margin-left:5px'"
                      style="width: 100%; height:358px;border-radius: 10px;object-fit:contain;background-color: #f1f1f1;"
                      :src="item[ninefield.img]+'?image_process=resize,l_200'"/>
                      <!-- <div style="position:relative">
                      <div :key="nineImgKey" style="height:30px;width:30px;color:#000;background-color:#999;border-radius:5px;position: absolute; z-index: 502; right: 5px; bottom: 10px; background: rgba(0,0,0,0.2); display: flex; justify-content: center; align-items: center; cursor: pointer;">
                        <i class="el-icon-zoom-in"></i>
                      </div>
                    </div>
                    <div style="position:relative">
                      <div :key="nineImgKey" style="height:30px;width:30px;color:#000;background-color:#999;border-radius:5px;position: absolute; z-index: 502; right: 5px; bottom: 10px; background: rgba(0,0,0,0.2); display: flex; justify-content: center; align-items: center; cursor: pointer;">
                        {{ pageNum }}
                      </div>
                    </div> -->
                  </div>
                  </viewer>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!-- 四宫格 end -->
        <!-- 九宫格 start -->
        <div class="clearfix-cc" v-else>
          <viewer ref="viewer" :images="srcList">
            <div class="conc_nine1" v-for="(item,index) in data" :key="index" @click="onnine(item,index)" :class="item.isSelect?'conc_nine1_s2':'conc_nine1_s1'">
              <div class="conc_nine1_p1" @mouseover="onshownine(index)" @mouseout="onhidenine(index)">
                <img :src="index == preIndex?item[ninefield.img]:item[ninefield.img]+'?image_process=resize,l_200'" @click="preShow(item[ninefield.img],index)" :key="nineImgKey"/>
                <div style="position: relative;top: -30px;">
                  <div class="chao1-cc" style="position: absolute;height: 30px;background-color: #fff;color: #000;font-size: 12px;line-height: 30px;padding-left: 5px;padding-right: 5px;border-radius: 0px 10px 0px 0px;opacity: 0.6;" v-if="ninefield.name4 != '' && ninefield.name4 != null">{{item[ninefield.name4]}}</div>
                </div>
                <div style="position: relative;top: -30px;">
                  <div class="chao1-cc" style="position: absolute;right:0px;height: 30px;background-color: #fff;color: #000;font-size: 12px;line-height: 30px;padding-left: 5px;padding-right: 5px;border-radius: 10px 0px 0px 0px;opacity: 0.6;" v-if="ninefield.name5 != '' && ninefield.name5 != null">{{item[ninefield.name5]}}</div>
                </div>
                <div style="position: relative;top: -178px;">
                  <div class="chao1-cc" style="position: absolute;height: 30px;background-color: #fff;color: #000;font-size: 12px;line-height: 30px;padding-left: 5px;padding-right: 5px;border-radius: 15px 0px 10px 0px;opacity: 0.6;max-width:87px;" v-if="ninefield.name6 != '' && ninefield.name6 != null">{{item[ninefield.name6]}}</div>
                </div>
                <div style="position: relative;top: -178px;">
                  <div class="chao1-cc" style="position: absolute;right:0px;height: 30px;background-color: #fff;color: #000;font-size: 12px;line-height: 30px;padding-left: 5px;padding-right: 5px;border-radius: 0px 15px 0px 10px;opacity: 0.6;max-width:87px;" v-if="ninefield.name7 != '' && ninefield.name7 != null">{{item[ninefield.name7]}}</div>
                </div>
                <div style="position: relative;top: -50px;" v-if="showsearch">
                  <div class="conc_nine1_p1a" :style="(isshownine && nineindex == index)?'':'display:none;'">
                    <div class="conc_nine1_p1as" @click="onothernine(2,item)" v-if="isiconsearch">
                      <i class="el-icon-search"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="conc_nine1_p2" @mouseover="onhidenine(index)">
                <div style="display: flex;align-items: center;" class="conc_nine1_p2a">
                  <div :class="(isshowname && nineindex == index)?'chao2-cc':'chao1-cc'" style="color: #000;font-size:14px;flex:1;text-align: left;" @click="isshowname = !isshowname" @mouseout="isshowname = false">{{ item[ninefield.name1] }} <span v-if="ninefield.name2 != ''">[{{ item[ninefield.name2] }}]</span></div>
                  <div style="color: #999;font-size: 12px;text-align: right;" v-if="!isshowname || nineindex != index">{{ handletime(item[ninefield.time],ninefield.ishandletime) }}</div>
                </div>
                <div style="display: flex;align-items: center;" class="conc_nine1_p2a" v-if="!isshowname || nineindex != index">
                  <div class="chao1-cc" style="flex:1;text-align: left;">
                    <span style="font-size:12px;color: #E6A23C;" v-if="ninefield.price == ''">{{item[ninefield.price2]}}</span>
                    <span style="color: #f00;font-size:14px;" v-else>{{ninefield.priceunit == ''?'￥':ninefield.priceunit}}<span style="font-weight: bold;">{{item[ninefield.price]}}</span></span>
                  </div>
                  <div class="conc_nine1_p2ab" v-if="ninefield.no == 'selectCount'"><span v-if="ninefield.name3 != '' && item[ninefield.no] > 0" style="font-size: 12px;">{{ ninefield.name3 }}</span><span v-if="item[ninefield.no] > 0">{{item[ninefield.no]}}</span><button v-if="ninefield.isninedit" class="el-icon-edit conc_nine1_p2as" @click="onothernine(1,item)"></button></div>
                  <div class="conc_nine1_p2ab" v-else-if="ninefield.no != '' && ninefield.no != 'selectCount'">{{item[ninefield.no]}}</div>
                  <button v-else-if="isshowedit && ninefield.no != 'selectCount'" class="conc_nine1_p2as" @click="onothernine(1,item)">{{ninefield.edittext || '编辑'}}</button>
                  <div v-else-if="isnineViewct" @click.stop="">
                    <button class="conc_nine1_p2as" @click="onothernine(3,item)">查看</button>
                  </div>
                </div>
              </div>
            </div>
          </viewer>
          <div style="width: 100%;" v-if="data.length == 0">
            <img
              style="width: 224px; height: 131px"
              src="../../../static/img/tableempty.png"
            />
            <span style="display: block; line-height: 30px">暂无数据</span>
          </div>
        </div>
        <!-- 九宫格 end -->
      </div>
      <!--分页-->
      <div style="display: flex;align-items: center;padding: 5px 0;width: 100%;" v-if="hasPagination">
        <div style="flex: 1;" v-if="!ninetoggle"></div>
        <div style="display: flex;align-items: center;" v-if="!ninetoggle && isnineSelect && !isnineEcho">
          <el-button type="primary" size="mini" @click="onnineselect(true)">确定</el-button>
          <el-button size="mini" style="margin-left: 10px;" @click="onnineselect(false)">取消</el-button>
        </div>
        <div style="flex: 1;">
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="paginationSizes"
          :page-size="size"
          :pager-count="4"
          :total="total"
          :small="isSmall"
          style="text-align: right;"
          :layout="paginationLayout"
        ></el-pagination>
        </div>
      </div>
      <!--对话框-->
      <el-dialog
        v-dialogDrag
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        v-if="hasDialog"
        :close-on-click-modal="false"
        :append-to-body="modalAppendToBody"
        @close="onCloseEdit()"
        @opened="openFunc"
        :width="dialogWidth"
        class="newDialog"
      >
        <slot name="topform"></slot>
        <component :is="comp" ref="dynamic" :key="compKey"></component>
        <slot name="form"></slot>
        <div v-show="isView">
          <slot name="viewform"></slot>
        </div>
        <div slot="footer" v-show="!isView">
          <el-button style="padding: 7px;" @click="cancel">{{
            $t("action.cancel")
          }}</el-button>
          <el-button
            style="padding: 7px;"
            type="primary"
            @click="sure"
            :loading="confirmLoading"
          >
            {{ $t("action.comfirm") }}</el-button
          >
          <el-button
            v-if="isWorkflow"
            style="padding: 7px;"
            type="warning"
            @click="sure('isWorkflowFunc')"
            :loading="confirmLoading"
            >{{ $t("workflow.Saveandinitiateapproval") }}</el-button
          >
          <slot name="dialogButton"></slot>
        </div>
      </el-dialog>

      <!--高级查询-->
      <transition name="fade">
        <el-dialog
          id="searchDialog"
          v-dialogDrag
          :title="searchTitle"
          :visible.sync="searchTitledialogVisible"
          :modal-append-to-body="searchModalAppendToBody"
          v-if="searchDataForm.length > 0"
          v-on:open="searchOpen"
          :append-to-body="appendToBody"
        >
          <!--https://github.com/FEMessage/el-form-renderer-->
          <!-- v-bind:dvalue="sValue"   如果高级查询下次打开需要重置数据加上这个 -->
          <el-form-renderer
            class="senior-serach-style" style="margin-left: 10px;"
            :content="searchDataForm"
            ref="searchDialogForm"
            v-bind="formAttrs"
            :key="searchKey"
          >
            <!--@slot 额外的弹窗表单内容, 当form不满足需求时可以使用 -->
            <slot name="searchslot"></slot>
          </el-form-renderer>

          <div slot="footer">
            <el-button
              style="padding: 7px;"
              type="primary"
              @click="addHighFind"
              size="mini"
              >{{ $t("action.add") }}
            </el-button>
            <el-button
              style="padding: 7px;"
              @click="seniorResetSearch"
              size="mini"
              >{{ $t("action.reset") }}</el-button
            >
            <el-button
              style="padding: 7px;"
              type="primary"
              @click="seniorSearch"
              :loading="confirmLoading"
              size="mini"
            >
              {{ $t("action.search") }}</el-button
            >
          </div>
        </el-dialog>
      </transition>
    </div>
    <!-- 审批组件 -->
    <new-work-flow-client
      v-if="workFlowClientshow"
      @end="loadend"
      @back="workflowGoback"
      :id="routeId"
      :rowdatas="saverow"
      :defaultWorkflowDialog="defaultWorkflowDialog"
      :tableprocessKey="tableprocessKey"
      ref="wfc"
      style="height: 90%"
    >
    </new-work-flow-client>
    <!-- 输入表格放大 -->
    <el-dialog v-dialog-drag
               :title="textTitle"
               :close-on-click-modal="false"
               :visible.sync="choiceShow"
               width="30%"
               class="inputDialog"
    >
      <el-form-item label=""
                    label-width="0"
      >
        <el-input v-model="longText"
                  :placeholder="'请输入' + textTitle"
                  type="textarea"
                  maxlength="30000"
				          :readonly="!hasOperEdit"
                  :rows="8"
        ></el-input>
      </el-form-item>
      <span slot="footer"
            class="dialog-footer"
      >
        <el-button size="mini"
                   @click="cancelConc"
        >
          取 消
        </el-button>
        <el-button type="primary" v-if="hasOperEdit"
                   size="mini"
                   @click="dialogConc"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import _get from "lodash.get";
import qs from "qs";
import ElFormRenderer from "@/components/XyjRenderer";
import XyjMultilevelHeader from "./xyjMultilevelHeader";
import GenerateForm from "@/components/vueformmaking/GenerateForm";
import rules from "@/utils/rules";
import axios from "@/http/axios";
import jquery from "jquery";
import Cookies from "js-cookie";

// 赋予table发送请求的能力
//Vue.prototype.$xyjaxios = tableAxios
// 操作成功后需要用到消息提醒
//Vue.prototype.$message = Vue.$me
// 删除操作需要用到确认提示
//// Vue.prototype.$confirm = MessageBox.confirm

// 默认返回的数据格式如下
//          {
//            "code":0,
//            "msg":"ok",
//            "payload":{
//              "content":[], // 数组
//              "totalElements":2, // 总数
//            }
//          }
// 可根据实际情况传入 data/total 两个字段的路径, 分别对应上面数据结构中的 content/totalElements
// 如果接口不分页, 则传hasPagination=false, 此时数据取 payload, 当然也可以自定义, 设置dataPath即可

/**
 *  
 *  分页请求默认第几页
 * */
const defaultFirstPage = 1;

/**
 *  
 *  默认值,返回的数据中的路径, 嵌套对象使用.表示即可
 * */
const dataPath = "payload.content";

const totalPath = "payload.totalElements";

const noPaginationDataPath = "payload";

/**
 *  
 *  默认值,子节点的字段名
 * */
const treeChildKey = "children";

/**
 *  
 *  默认值,父节点的字段名
 * */
const treeParentKey = "parentId";

/**
 *  
 *  默认值,父节点字段值的来源字段
 * */
const treeParentValue = "id";

/**
 *  
 *  主键默认ID
 * */
const defaultId = "id";

const dialogForm = "dialogForm";

const equal = "=";

const equalPattern = /=/g;

const valueSeparator = "~";

const paramSeparator = ",";

const valueSeparatorPattern = new RegExp(valueSeparator, "g");

const queryFlag = "q=";

const queryPattern = new RegExp("q=.*" + paramSeparator);

//选择字段下拉框
let fieldsDown = {
  $id: "",
  $type: "select",
  label: "",
  $default: "",
  $el: {
    placeholder: "请选择字段",
    style: "width: 150px", //组件宽度
    filterable: true //所搜
  },
  $options: []
};

//关系运算符
let relationship = {
  $id: "",
  $type: "select",
  label: "",
  $default: "",
  $el: {
    placeholder: "请选择关系符",
    style: "width: 110px" //组件宽度
  },
  $options: [
    { label: "等于", value: "EQUAL", type: "EQ" },
    { label: "不等于", value: "NOT_EQUAL", type: "NE" },
    { label: "相似", value: "LIKE", type: "LK" },
    { label: "等于忽略大小写", value: "EQUAL_IGNORE_CASE", type: "EIC" },
    { label: "小于", value: "LESS", type: "LT" },
    { label: "小于等于", value: "LESS_EQUAL", type: "LE" },
    { label: "大于", value: "GREAT", type: "GT" },
    { label: "大于等于", value: "GREAT_EQUAL", type: "GE" },
    { label: "左相似", value: "LEFT_LIKE", type: "LFK" },
    { label: "右相似", value: "RIGHT_LIKE", type: "RHK" },
    { label: "为空", value: "IS_NULL", type: "ISNULL" },
    { label: "非空", value: "NOTNULL", type: "NOTNULL" },
    { label: "在...中", value: "IN", type: "IN" },
    { label: "在...之间", value: "BETWEEN", type: "BETWEEN" }
  ]
};

//并且或者关系
let andOr = {
  $id: "",
  $type: "select",
  width: "50px",
  label: "",
  $el: {
    placeholder: "请选择",
    style: "width: 80px" //组件宽度
  },
  $default: "AND",
  $options: [
    { label: "并且", value: "AND" },
    { label: "或者", value: "OR" }
  ]
};
//输入值对象
let inputValue = {
  $id: "", // 每一个原子都存在id，用于存储该原子的值，注意不能重复
  $type: "input", // 类型，element 提供的所有表单类型，即 el-xxx
  label: "", // el-form-item上的属性,
  $el: {
    placeholder: "请输入",
    style: "width: 130px "
  }
};

//删除对象
let deleteButton = {
  $id: "",
  $groupid: 0,
  $type: "button",
  $el: {
    type: "button",
    icon: "el-icon-delete",
    circle: true,
    style: "color: #FF0800",
    disabled: false
  }
};
/**
 *  
 *  深度克隆对象的方法	 -- > 深层拷贝，对象属性方法一致，单都是单独的个体。
 * */
function clone(obj) {
  var result = Array.isArray(obj) ? [] : {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === "object" && obj[key] != null) {
        result[key] = clone(obj[key]); //递归复制
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
}

/**
 *  
 *  深度克隆对象的方法	 -- > 深层拷贝，对象属性方法一致，单都是单独的个体。
 * */
function columnClone(obj) {
  // console.log('obj',obj)
  var result = Array.isArray(obj) ? [] : {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === "object" && obj[key] != null) {
        result[key] = columnClone(obj[key]); //递归复制
      } else {
        if (
          key.toLowerCase() === "resizable" ||
          key.toLowerCase() === "fixed"
        ) {
          result[key] = obj[key] === 1 ? true : false;
        } else if (key.toLowerCase() === "showoverflow") {
          result["show-overflow-tooltip"] = obj[key] === 1? true : false;
        } else if (
          key.toLowerCase() === "prop" &&
          obj[key].toLowerCase() === "select"
        ) {
          result["type"] = "selection";
          result[key] = obj[key];
        } else {
          result[key] = obj[key];
        }
      }
    }
  }
  return result;
}

/**
 *  
 *  整理初始化列数据
 * */
function ArrangementColumns(columns) {
  let tmpArray = [];
  let tmpcolumns = columns.sort(function(a, b) {
    return a.arrange - b.arrange;
  });
  tmpcolumns.forEach((column, index) => {
    tmpArray.push(column);
    if (column.children && column.children.length) {
      let tmpchildren = column.children.sort(function(a, b) {
        return a.arrange - b.arrange;
      });
      tmpArray = tmpArray.concat(ArrangementColumns(tmpchildren));
    }
  });
  return tmpArray;
}
function changeBoolean(source) {
  if (typeof source !== "object") {
    if (typeof source[attr] === "boolean") {
      return source ? 1 : 0;
    } else {
      return source;
    }
  }
  var _obj = Array.isArray(source) ? [] : {};
  if (source.constructor === Object) {
    for (var attr in source) {
      if (source[attr] === null || source[attr] === undefined) {
        _obj[attr] = null;
      } else if (source[attr].constructor === Object) {
        _obj[attr] = deepClone(source[attr]);
      } else {
        if (source[attr].constructor === Boolean) {
          _obj[attr] = source[attr] ? 1 : 0;
        } else if (source[attr].constructor === Array) {
          for (let i = 0, ni = source[attr].length; i < ni; i++) {
            _obj[attr] = [];
            for (let item in source[attr])
              _obj[attr][item] = source[attr][item];
          }
        } else {
          _obj[attr] = source[attr];
        }
      }
    }
    return _obj;
  }
}
/**
 *  
 *  将表格列信息转换为输入组建
 * */
function convertInput(column,ismonth = false) {
  switch (column.fieldType) {
    case "input":
      return {
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $type: "input", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性,
        $el: {
          placeholder: "请输入" + column.label,
          style: "width: 150px",
          //maxlength: (column.datalength/2)-1, //原生属性，最大输入长度
          disabled: false,
          // "show-word-limit": true,
          clearable: true,
          size: "small"
        },
        $options: [],
        $default: "", //默认值
        rules: {}
      };
    case "select":
      return {
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $type: "select", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性
        $el: {
          placeholder: "请选择" + column.label,
          style: "width: 150px",
          filterable: true, //所搜
          disabled: false,
          clearable: true, //清空选择
          size: "small"
        },
        $options: [], //格式{label: '显示内容',value: '值'}
        $default: "", //默认值
        rules: {} // el-form-item上的属性
      };
    case "selectMultiple":
      return {
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $type: "select", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性
        $el: {
          placeholder: "请选择" + column.label,
          style: "width: 150px",
          //          filterable: true, //所搜
          disabled: false,
          clearable: true, //清空选择
          size: "small",
          multiple: true
        },
        $options: [], //格式{label: '显示内容',value: '值'}
        $default: [], //默认值
        rules: {} // el-form-item上的属性
      };
    case "radioGroup":
      return {
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $el: {
          disabled: false
        },
        $type: "radio-group", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性,,
        $options: [], //格式{label: '显示内容',value: '值'}
        $default: "", //默认值
        rules: column.rule // el-form-item上的属性
      };
    case "radioButton":
      return {};
    case "checkboxGroup":
      return {
        $el: {
          disabled: false
        },
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $type: "checkbox-group", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性,
        $default: [], //默认值
        $options: [], //格式{label: '显示内容',value: '值'}
        rules: {} // el-form-item上的属性
      };
    case "checkboxButton":
      return {};
    case "textarea":
      return {
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $type: "input", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性
        $el: {
          type: "textarea",
          rows: "3",
          placeholder: "请输入" + column.label,
          style: "width: 150px",
          maxlength: column.maxlength, //原生属性，最大输入长度
          disabled: false
        },
        $options: [],
        $default: "", //默认值
        rules: {}
      };
    case "datePicker":
      return {
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $type: "date-picker", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性
        $el: {
          type: "datetimerange",
          clearable: true,
          startPlaceholder: "请选择开始日期" + column.label,
          endPlaceholder: "请选择结束日期" + column.label,
          style: "width: 150px",
          valueFormat: "yyyy-MM-dd HH:mm:ss",
          format: "yyyy-MM-dd HH:mm:ss",
          disabled: false
        },
        $options: [],
        $default: "", //默认值
        /*outputFormat: function outputFormat(val) {
          return {
            startDate: val[0],
            endDate: val[1],
          };
        },*/
        rules: {}
      };
    case "singleDate":
      return {
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $type: "date-picker", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性
        $el: {
          type: "datetime",
          clearable: true,
          placeholder: "请选择" + column.label,
          style: "width: 150px",
          valueFormat: "yyyy-MM-dd HH:mm:ss LZT",
          format: "yyyy-MM-dd HH:mm:ss",
          disabled: false
        },
        $options: [],
        $default: "", //默认值
        /*          outputFormat: function outputFormat(val){
            return {
              sDate: val[0],
            };
          },*/
        rules: {}
      };
    case "date":
      return {
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $type: "date-picker", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性
        $el: {
          type: "date",
          clearable: true,
          placeholder: "请选择" + column.label,
          style: "width: 150px",
          valueFormat: "yyyy-MM-dd LZ",
          format: "yyyy-MM-dd",
          disabled: false,
          size: "small"
        },
        $options: [],
        $default: "", //默认值
        rules: {}
      };
    case "month":
      return {
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $type: "date-picker", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性
        $el: {
          type: "month",
          clearable: true,
          placeholder: "请选择" + column.label,
          style: "width: 150px",
          valueFormat: ismonth?"yyyy-MM":"yyyy-MM LNY",
          format: "yyyy-MM",
          disabled: false,
          size: "small"
        },
        $options: [],
        $default: "", //默认值
        rules: {}
      };
    case "hourminute": //小时分钟
      return {
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $type: "time-picker", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性
        $el: {
          type: "datetime",
          clearable: true,
          placeholder: "请选择" + column.label,
          style: "width: 150px",
          valueFormat: "HH:mm LTXF",
          format: "HH:mm",
          disabled: false
        },
        $options: [],
        $default: "", //默认值
        rules: {}
      };
    case "hour": //小时分钟
      return {
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $type: "time-picker", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性
        $el: {
          type: "datetime",
          clearable: true,
          placeholder: "请选择" + column.label,
          style: "width: 150px",
          valueFormat: "HH LTX",
          format: "HH",
          disabled: false
        },
        $options: [],
        $default: "", //默认值
        rules: {}
      };
    case "switch":
      return {
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $el: {
          disabled: false
        },
        $type: "switch", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性
        $options: [],
        $default: true,
        rules: {}
      };
    case "upload":
      return {
        $id: column.prop, // 每一个原子都存在id，用于存储该原子的值，注意不能重复
        $el: {
          disabled: false,
          action: "",
          showFileList: false,
          httpRequest: function(file) {}
          // drag:true,
        },
        $type: "upload", // 类型，element 提供的所有表单类型，即 el-xxx
        label: column.label, // el-form-item上的属性
        $options: [],
        $default: "",
        rules: {},
        // $style:{
        //   tagName:"el-button",
        //   props:{
        //     type:"primary",
        //     size:"small"
        //   },
        //   text:"上传文件"
        // },
        $style: {
          tagName: "el-input",
          props: {
            size: "small",
            placeholder: "点击选择上传文件"
          },
          text: ""
        }
      };
      break;
    default:
      return {};
  }
}

export default {
  name: "xyjtableDragNew",
  components: {
    XyjMultilevelHeader,
    ElFormRenderer,
    GenerateForm
  },
  props: {
    // 复选框事件，可以用来禁用符合条件的复选框，参考element-ui官网该方法使用
    selectable: {
      type: Function
    },
    /*  
     *   新增编辑弹框遮罩层是否插入至body元素上，若为false，则遮罩插入至dialog的父元素上
     */
    modalAppendToBody: {
      type: Boolean,
      default: false
    },
    /*  
     *   高级查询弹框遮罩层是否插入至body元素上，若为false，则遮罩插入至dialog的父元素上
     */
    searchModalAppendToBody: {
      type: Boolean,
      default: true
    },
    /*  
     *   批量删除按钮文字
     */
    deleteText: {
      type: String
    },
    /*  
     *   审批字段用于控制审批按钮禁用
     */
    workflow: {
      type: String
    },
    /*  
     *   启用停用字段
     */
    ifDisabled: {
      type: String
    },
    /*  
     *   启用的值
     */
    defaultDisabledValue: {
      type: String
    },
    /*  
     *   删除文字
     */
    deleteText1: {
      type: String
    },
    /*  
     *   图片样式
     */
    img: {
      type: Object,
      default() {
        return {
          width: "60px",
          height: "40px"
        };
      }
    },
    /*  
     *   批量删除按钮是否显示
     */
    batchDelete: {
      type: Boolean,
      default: false
    },
    /*  
     *   请求url, 如果为空, 则不会发送请求; 改变url, 则table会重新发送请求
     */
    url: {
      type: String,
      default: ""
    },
    /*  
     *   业务微服务服务器URL地址, 如果为空, 则不会发送请求; bQuery
     */
    bQuery: {
      type: Object,
      default() {
        return {
          notCondition: true, //true:空条件查询，false：空条件不查询
          hostUrl: this.zuul,
          url: "",
          method: "post"
        };
      }
    },
    /*
     *   业务微服务服务器URL地址,导出
     */
    bExport: {
      type: Object,
      default() {
        return {
          bExport: {
            hostUrl: this.zuul, //请求导出网址
            url: "", //导出查询网址
            tableName: "", //导出表的表名
            fileName: "" //自定义文件名,如果为空则根据实体类名称定义下载文件名
          }
        };
      }
    },
    /*  
     *   业务微服务服务器URL地址,新增
     */
    bNewUrl: {
      type: Object,
      default() {
        return {
          hostUrl: this.zuul,
          url: "",
          method: "post"
        };
      }
    },
    /*  
     *   业务微服务服务器URL地址,修改
     */
    bEditUrl: {
      type: Object,
      default() {
        return {
          hostUrl: this.zuul,
          url: "",
          method: "post"
        };
      }
    },
    /* 
     *   业务微服务服务器URL地址,删除
     */
    bDeleteUrl: {
      type: Object,
      default() {
        return {
          hostUrl: this.zuul,
          url: "",
          method: "post"
        };
      }
    },
    /*  
     *   业务微服务服务器URL地址,启用停用
     */
    bDisabled: {
      type: Object,
      default() {
        return {
          hostUrl: this.zuul,
          url: "",
          method: "post"
        };
      }
    },
    /*  
     *   服务器URL地址, 如果为空, 则不会发送请求; 改变hostUrl, 则table会重新发送请求
     */
    hostUrl: {
      type: String,
      default: this.zuul
    },
    /* 
     *   表格初始化的关键字，一般是表名，对应系统表（sys_tableinfo）的tablename字段
     */
    tableName: {
      type: String,
      default: ""
    },
    /*  
     *   表格初始化的实体类名字+菜单名称
     */
    pageName: {
      type: String,
      default: ""
    },
    /*  conc
     *   是否显示小提示
     */
     showtips: {
      type: Boolean,
      default: true
    },
    /*  conc
     *   是否处理月份搜索
     */
     ismonth: {
      type: Boolean,
      default: false
    },
    /*  
     *   表格初始化的项目编号
     */
    projectCode: {
      type: String,
      default: ""
    },
    /**
     *  主键，默认值 id
     *  修改/删除时会用到,请求会根据定义的属性值获取主键,即row[this.id]
     */
    id: {
      type: String,
      default: defaultId
    },
    /**
     * 分页请求的第一页的值(有的接口0是第一页)
     */
    firstPath: {
      type: Number,
      default: defaultFirstPage
    },
    /**
     * 渲染组件的分页数据在接口返回的数据中的路径, 嵌套对象使用.表示即可
     */
    dataPath: {
      type: String,
      default: dataPath
    },
    /**
     * 分页数据的总数在接口返回的数据中的路径, 嵌套对象使用.表示即可
     */
    totalPath: {
      type: String,
      default: totalPath
    },
    /**
     * 列属性设置, 详情见element-ui官网
     */
    columns: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * 列属性设置, 详情见element-ui官网
     */
    searchForm: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * 点击查询按钮, 查询前执行的函数, 需要返回Promise
     */
    beforeSearch: {
      type: Function,
      default() {
        return Promise.resolve();
      }
    },
    /**
     * 路由模式, hash | history || '', 决定了查询参数存放的形式, 设置为空则不存储查询参数
     */
    routerMode: {
      type: String,
      default: "hash"
    },
    /**
     * 单选, 适用场景: 不可以批量删除
     */
    single: {
      type: Boolean,
      default: false
    },
    /**
     * 是否有操作列
     */
    hasOperation: {
      type: Boolean,
      default: true
    },
    /**
     * conc：20230516
     * 表格是否可直接编辑
     */
     hasOperEdit: {
      type: Boolean,
      default: false
    },
    /**
     * conc：20230516
     * 表格可直接编辑下是否禁止输入 默认否
     */
    hasOperView:{
      type: Boolean,
      default: false
    },
    /**
     * conc：20230516
     * 表格可编辑禁用配置
     */
    notDdit:{
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * 操作列的自定义按钮, 渲染的是element-ui的button, 支持包括style在内的以下属性:
     * {type: '', text: '', atClick: row => Promise.resolve(), show: row => return true时显示 }
     * 点击事件 row参数 表示当前行数据, 需要返回Promise, 默认点击后会刷新table, resolve(false) 则不刷新
     */
    extraButtons: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * 操作列的自定义按钮需要替换的文字和方法
     * 点击事件 row参数 表示当前行数据, 需要返回Promise, 默认点击后会刷新table, resolve(false) 则不刷新
     */
    changeBtns: {
      type: Array,
      default() {
        return [];
      }
    },
    //是否有导出按钮
    hasExport: {
      type: Boolean,
      default: false
    },
    /**
     * 是否有新增按钮
     */
    hasNew: {
      type: Boolean,
      default: false
    },
    /**
     * 是否有编辑按钮
     */
    hasEdit: {
      type: Boolean,
      default: true
    },
    /**
     * 是否有查看按钮
     */
    hasView: {
      type: Boolean,
      default: false
    },
    /**
     * 是否有停用启用按钮
     */
    hasDisable: {
      type: Boolean,
      default: false
    },
    /**
     * table头部是否有删除按钮(该按钮要多选时才会出现)
     */
    hasDelete: {
      type: Boolean,
      default: false
    },
    /**
     * 是否有快速查询
     */
    hasSearch: {
      type: Boolean,
      default: true
    },
    /**
     * 是否有快速查询
     */
    hasSort: {
      type: Boolean,
      default: true
    },
    /**
     * table表格是否有展开行
     */
    isExpand: {
      type: Boolean,
      default: false
    },
    /*  conc：20230328
     *   审批中表格是否默认查询id
     */
    isinquire: {
      type: Boolean,
      default: true
    },
    /**
     * 是否执行审批方法
     */
    isWorkflow: {
      type: Boolean,
      default: false
    },
    dialogWidth: {
      type: String,
      default: "40%"
    },
    /**
     *  某行数据是否可以删除, 返回true表示可以, 控制的是单选时单行的删除按钮
     */
    canDelete: {
      type: Function,
      default() {
        return true;
      }
    },
    /**
     * 点击新增按钮时的方法, 当默认新增方法不满足需求时使用, 需要返回promise
     * 参数(data, row) data 是form表单的数据, row 是当前行的数据, 只有isTree为true时, 点击操作列的新增按钮才会有值
     */
    onNew: {
      type: Function
    },
    /**
     * 点击新增按钮执行成功之后的方法
     * 参数(data, row) data 是form表单的数据, row 是当前行的数据, 只有isTree为true时, 点击操作列的新增按钮才会有值
     */
    onAfterSuccessNew: {
      type: Function
    },
    /**
     *描述：点击编辑按钮执行成功之后的方法
     * 参数(data, row) data 是form表单的数据, row 是当前行的数据, 只有isTree为true时, 点击操作列的新增按钮才会有值
     *版本：1.0
     */
    onAfterSuccessEdit: {
      type: Function
    },
    /**
     * 点击新增按钮执行失败之后的方法
     * 参数(data, row) data 是form表单的数据, row 是当前行的数据, 只有isTree为true时, 点击操作列的新增按钮才会有值
     */
    onAfterFailNew: {
      type: Function
    },
    /**
     *描述：点击编辑按钮执行失败之后的方法
     * 参数(data, row) data 是form表单的数据, row 是当前行的数据, 只有isTree为true时, 点击操作列的新增按钮才会有值
     *版本：1.0
     */
    onAfterFailEdit: {
      type: Function
    },

    /**
     * 点击删除按钮执行成功之后的方法
     * 参数(selected) selected 是选择的数据
     */
    onAfterSuccessDelete: {
      type: Function
    },
    /**
     * 点击删除按钮执行失败之后的方法
     * 参数(selected, errinfo) selected 是选择的数据，errinfo：错误提示信息
     */
    onAfterFailDelete: {
      type: Function
    },
    /**
     * 点击修改按钮时的方法, 当默认修改方法不满足需求时使用, 需要返回promise
     * 参数(data, row) data 是form表单的数据, row 是当前行的数据
     */
    onEdit: {
      type: Function
    },
    /**
     * 点击修改按钮时的方法, 当修改默认方法上传数据时，使用,
     * 参数(data, row) data 是form表单的数据, row 是当前行的数据
     */
    onManualEdit: {
      type: Function
    },
    /**
     * 点击新增按钮时的方法, 当修改默认方法上传数据时，使用,
     * 参数(data, row) data 是form表单的数据, row 是当前行的数据
     */
    onManualNew: {
      type: Function
    },
    /**
     * 点击删除按钮时的方法, 当修改默认方法上传数据时，使用,
     * 参数(data, row) data 是form表单的数据, row 是当前行的数据
     */
    onManualDelete: {
      type: Function
    },
    /**
     * 点击删除按钮时的方法, 当默认删除方法不满足需求时使用, 需要返回promise
     * 多选时, 参数为selected, 代表选中的行组成的数组; 非多选时参数为row, 代表单行的数据
     */
    onDelete: {
      type: Function
    },
    /**
     * 新增时，处理有默认数据的表单
     */
    onDialogDefault: {
      type: Function
    },
    /**
     *描述：编辑对话关闭事件
     *版本：1.0
     */
    onEditDialogClose: {
      type: Function
    },
    /**
     * 点击新增按钮前，需要做的判断
     */
    onBeforeNew: {
      type: Function
    },
    /**
     * 点击编辑按钮前，需要做的判断
     */
    onBeforeEdit: {
      type: Function
    },
    /**
     * 是否分页
     */
    hasPagination: {
      type: Boolean,
      default: true
    },
    /**
     * 分页组件的子组件布局，子组件名用逗号分隔，对应element-ui pagination的layout属性
     */
    paginationLayout: {
      type: String,
      default: "total,sizes,prev,pager,next,jumper"
    },
    /**
     * 分页组件的每页显示个数选择器的选项设置，对应element-ui pagination的page-sizes属性
     */
    paginationSizes: {
      type: Array,
      default: () => [10, 20, 30, 40, 50, 100]
    },
    /**
     * 分页组件的每页显示个数选择器默认选项，对应element-ui pagination的page-size属性
     */
    paginationSize: {
      type: Number,
      default: 20
    },
    /**
     * 不分页时的size的大小
     */
    noPaginationSize: {
      type: Number,
      default: 999
    },
    /**
     * 要渲染的数据是否是树形结构
     */
    isTree: {
      type: Boolean,
      default: false
    },
    /**
     * 树形结构相关: 子节点的字段名
     */
    treeChildKey: {
      type: String,
      default: treeChildKey
    },
    /**
     * 树形结构相关: 父节点的字段名
     */
    treeParentKey: {
      type: String,
      default: treeParentKey
    },
    /**
     * 树形结构相关: 父节点字段值的来源字段。
     * 新增/修改时会用到, 例如, 在id为2的节点新增子节点, 则子节点的parentId为2, 也即parentId的值来源于字段id, 故treeParentValue为id
     */
    treeParentValue: {
      type: String,
      default: treeParentValue
    },
    /**
     * 树形结构相关: 是否展开所有节点
     */
    expandAll: {
      type: Boolean,
      default: false
    },
    /**
     * element table 属性设置, 详情配置参考element-ui官网
     */
    tableAttrs: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * element table 设置事件, 详情配置参考element-ui官网
     */
    tableOns: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * 操作列属性
     */
    operationAttrs: {
      type: Object,
      default() {
        return {
          width: "",
          fixed: "right",
          headerAlign: "center" //表头对齐方式，若不设置该项，则使用表格的对齐方式
        };
      }
    },
    /**
     * 是否有弹窗, 用于不需要弹窗时想减少DOM渲染的场景
     */
    hasDialog: {
      type: Boolean,
      default: true
    },
    /**
     * 高级查询对话框标题
     */
    searchTitle: {
      type: String,
      default: "高级查询对话框"
    },
    /**
     * 新增弹窗的标题
     */
    dialogNewTitle: {
      type: String,
      default: "新增"
    },
    /**
     * 修改弹窗的标题
     */
    dialogEditTitle: {
      type: String,
      default: "编辑"
    },
    /**
     * 查看弹窗的标题
     */
    dialogViewTitle: {
      type: String,
      default: "查看"
    },
    /**
     * 弹窗表单, 用于新增与修改, 详情配置参考el-form-renderer
     */
    form: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * 弹窗表单属性设置, 详情配置参考element-ui官网
     */
    formAttrs: {
      type: Object,
      default() {
        return {
          labelPosition: "right",
          labelWidth: "7em"
        };
      }
    },
    /**
     * 在新增/修改弹窗 点击确认时调用，返回Promise, 如果reject, 则不会发送新增/修改请求
     * 参数: (data, isNew) data为表单数据, isNew true 表示是新增弹窗, false 为 编辑弹窗
     */
    beforeConfirm: {
      type: Function,
      default() {
        return Promise.resolve();
      }
    },
    /** 点击审批之前的回调*/
    beforeWorkflow: {
      type: Function
    },
    /** 审批返回的回调 */
    workflowBackFunc: {
      type: Function
    },
    /**
     * 外部的注入额外的查询参数, 键值对形式
     */
    customQuery: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * 表格初始化时查询条件
     */
    InitQuery: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * 外部注入选择数据
     * */
    extraSelectData: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * 扩展cheng事件
     * */
    extraCheng: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * 前端手动修改控件属性
     * */
    extraAttribute: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * 表格列格式化
     * */
    formatters: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * 外部传送排序字段
     * */
    sorter: {
      type: Array,
      default: () => []
    },
    editAxios: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * @description: 新增按钮是否禁用
     * @param {type}
     * @return:
     */

    disabledNew: {
      type: Boolean,
      default() {
        return false;
      }
    },
    //导出按钮是否禁用
    disabledExport: {
      type: Boolean,
      default() {
        return false;
      }
    },
    image: {
      type: Array,
      default() {
        return [];
      }
    },
    // 高级查询弹框是否是嵌套子弹框
    appendToBody: {
      type: Boolean,
      default: false
    },
    // 添加流程树中的code查询条件
    codeVaule: {
      type: Function
    },
    //  排序时的查询条件
    sortVaule: {
      type: Function
    },
    selfDate: {
      type: Object,
      default() {
        return {};
      }
    },
    operationLabel: {
      type: String,
      default: "操作"
    },
    // 审批默认展示组件
    defaultWorkflowDialog: {
      type: String,
      default: ""
    },
    // 自定义排序 true:前端排序，false:后端排序
    isSelfSort: {
      type: Boolean,
      default: false
    },
    // 调用新增接口后是否刷新表格数据 true:刷新表格，false:不刷新，新增数据插入表格最后一条
    isRefresh: {
      type: Boolean,
      default: true
    },
    // 是否单选
    isMulitype: {
      type: Boolean,
      default: false
    },
    dataAuthority: {
      type: Boolean,
      default: false
    },
    // 是否显示表格、九宫格切换按钮
    isToggle: {
      type: Boolean,
      default: false
    },
    // 控制表格默认显示图片九宫格或者表格 true为默认表格
    showToggle: {
      type: Boolean,
      default: true
    },
    //是否自定义九宫格样式 默认不自定义
    isnineContent: {
      type: Boolean,
      default:false
    },
    // 切换回表格时的回调
    showTableToggle: {
      type: Function
    },
    // 是否只刷新合计行，默认false全部刷新
    countFlag: {
      type: Boolean,
      default: false
    },
    // 是否用新的审批
    newWorkflow: {
      type: Boolean,
      default: false
    },
    //九宫格样式
    nineStyle: {
      type: Object,
      default() {
        return {
          nineAll:{},//九宫格外部样式，用于控制宽高
        };
      }
    },
    //九宫格展示字段
    ninefield: {
      type: Object,
      default() {
        return {
          img:'',//图片img
          name1:'',//标题1 proCName
          name2:'',//标题2 treeName
          name3:'',//在no位置前面的文字
          name4:'',//显示左下位置
          name5:'',//显示右下位置
          name6:'',//显示左上位置
          name7:'',//显示右上位置
          no:'',//货号 no 等于空的时候显示编辑按钮 不等于空则显示对应字段
          price:'',//价格 price
          price2:'',//价格 位置替换内容
          priceunit:'￥',//价格单位 默认人民币
          time:'',//时间 createTime
          ishandletime:false,//是否处理时间
          isninedit:false,//是否带编辑按钮
          edittext:'编辑',//编辑处文字
        };
      }
    },
    //是否显示查找图片按钮
    isiconsearch:{
      type: Boolean,
      default: true
    },
    //是否九宫格选择模式 默认不能选择 即打开查看大图  true则表示选择
    isnineSelect:{
      type: Boolean,
      default: false
    },
    //九宫格选择模式下 增加一个可以查看详情的入口 2024-01-17
    isnineViewct:{
      type: Boolean,
      default: false
    },
    //选择模式下生效 true表示单选  false表示多选
    isnineRadio:{
      type: Boolean,
      default: false
    },
    //选择模式下生效 true表示开启选择实时返回已选数据，此模式下没有确定按钮
    isnineEcho:{
      type: Boolean,
      default: false
    },
    isnine2Echo:{
      type: Boolean,
      default: false
    },
    //九宫格模式下是否显示编辑按钮
    isshowedit:{
      type: Boolean,
      default: true
    },
    //九宫格模式下是否显示鼠标移近状态
    showsearch:{
      type: Boolean,
      default: true
    },
    //自定义查询条件
    pageConc:{
      type: Object,
      default() {}
    },
    //是否显示四宫格 显示四宫格，九宫格模式将不会显示 2024-02-28
    isSigongGrid:{
      type: Boolean,
      default: false
    }
  },
  provide() {
    return {
      processKey: this.processKey,
      defaultWorkflowDialog: this.defaultWorkflowDialog
    };
  },
  data() {
    return {
      workflowShowOperation: true,
      togoData: [],
      togloading: false,
      tableprocessKey: "",
      multipleSelection: [],
      processKey: null,
      ninetoggle: this.showToggle,//true=表格 false=九宫格
      isSmall:false,//是否小型分页
      saverow: {}, // 点击表格行的数据
      routeId: "", // 审批需要的routeid
      workFlowClientshow: false, // 审批组件是否显示
      searchKey: 0, // 刷新搜索框
      objname: "",
      searchItems: [],
      compKey: 0,
      comp: "",
      querydata: [], // 表格查询条件，宏兴石化项目导出使用，不是通用的
      /**
       *描述：无条件查询开关
       *版本：1.0
       */
      notCondition: false,
      expands: [],
      getRowKeys(row) {
        return row.id;
      }, // 表格展开行id
      // disabledNew: false, //控制新增按钮是否禁用 false:启用，true：禁用
      disabledEdit: false, //控制修改按钮是否禁用 false:启用，true：禁用
      disabledView: false, //控制查看按钮是否禁用 false:启用，true：禁用
      disabledDelete: false, //控制删除按钮是否禁用 false:启用，true：禁用
      disabled: false, // 新增修改时确定按钮只能点击一次
      data: [],
      newData:[],//四宫格数据
      hasSelect: false,
      mSelect: false, //是否有多选
      size: this.paginationSize || this.paginationSizes[0],
      page: defaultFirstPage,
      total: null,
      summary: [], //汇总条件
      summaryData: {}, //汇总数据
      loading: false,
      selected: [],
      customButtonsLoading: false,
      dialogTitle: this.dialogNewTitle,
      dialogVisible: false,
      buttonState: false,
      searchTitledialogVisible: false,
      isNew: true,
      isEdit: false,
      isView: false,
      confirmLoading: false,
      ///当前修改的那一行
      row: {},
      // 初始的customQuery值, 重置查询时, 会用到
      // JSON.stringify是为了后面深拷贝作准备
      initCustomQuery: JSON.stringify(this.customQuery),
      rule: rules, //校验对象
      searchDataForm: [], //高级查询框动态数据
      getQuickSearchs: [], // 普通查询数据
      tableColumns: this.columns, //父组件传入默认值
      dialogFrom: this.form, //新增，修改，查看数据组件
      allTableColumns: [], //多级表头数据合成一级表头数据
      fieldSelectValue: [], //字段选择数据
      sValue: {}, //快速查询值,
      inputSelect: {}, //用户手动输入数据，防止多次请求,
      xyjSorter: clone(this.sorter), //排序
      xyjformAttrs: this.formAttrs,
      searchMessage: "",
      /* 分页每页条数改变时带上查询条件 */
      sizeChangeQuery: {},
      tableHeadList:[],
      selected: [],
      isRequest: true, // 是否请求
      onpeid:'',
      onpeprop:'',
      isred:false,//当前输入框是否为红色
      putedit:'<span style="border-bottom: 1px solid rgb(89, 120, 222);color: rgb(89, 120, 222);font-size:12px;">点击编辑</span>',
      textTitle:'',
      choiceShow:false,//表格编辑弹窗
      longText:'',//编辑字段内容（弹窗内容）
      longId:'',//编辑数据id
      longProp:'',//编辑字段名称
      longRow:'',//编辑数据
      longIndex:0,//编辑数据index
      longifEntryRequired:0,//编辑字段是否必填 1是  0否
      isshownine:false,//鼠标移近  是否显示
      isshowname:false,//九宫格文件名称是否显示两行
      nineindex:'',//当前移近目标
      nineselect:-1,//当前选择目标
      selectList:[],//选中列表
      // 预览添加参数
      preIndex: 0,
      srcList: [],
      nineImgKey:0,//图片key
      //2024-02-28 走马灯
      isDragging: false,
      startX: 0,
      currentTranslate: 0,
      containerWidth: 0,
      carouselWidth: 0,
      pageNum:0,//四宫格索引，从0开始
      pageTwo:1,//分页页数，默认从1开始，切换四宫格时累加
      pageTnum:0,//四宫格索引，从0开始 切换分页时在赋值 用于判断幻灯片切换方向
      pageTwoList:[1],//已请求分页页数集合
    };
  },
  watch: {
    url: function(val, old) {
      this.page = defaultFirstPage;
      this.getList();
    },
    dialogVisible: function(val, old) {
      if (!val) {
        this.isNew = false;
        this.isEdit = false;
        this.isView = false;
        this.confirmLoading = false;
        this.$refs.dynamic.$refs.generateForm.updateModels &&
          this.$refs.dynamic.$refs.generateForm.updateModels();
      }
    },
    searchTitledialogVisible: function(val, old) {
      if (!val) {
        this.confirmLoading = false;
      }
    },
    isnineSelect(val){
      if (val) {
        this.nineImgKey++;
      }
    },
    pageConc(val){
      if (val) {
        // console.log('pageConc',val)
        this.size = val.pageSize;
        this.page = val.page;
      }
    }
  },
  methods: {
    //2024-02-28 走马灯拖动
    handleMouseDown(event) {
      this.isDragging = true;
      this.startX = event.clientX;
      // console.log('startX',this.startX)
    },
    handleMouseMove(event) {
      if (this.isDragging) {
        this.isDragging = false
        const deltaX = event.clientX - this.startX;
        this.currentTranslate += deltaX;

        // 防止超出边界
        const minTranslate = this.containerWidth - this.carouselWidth;
        this.currentTranslate = Math.max(minTranslate, Math.min(0, this.currentTranslate));
        console.log('deltaX',deltaX)
        // 不直接更新走马灯位置，而是根据滑动方向触发上下切页
        if (deltaX > 0.3) {
          this.$refs.carousel.prev();
        } else if(deltaX < -0.3) {
          this.$refs.carousel.next();
        }

        this.startX = event.clientX;
      }
    },
    handleMouseUp() {
      this.isDragging = false;
    },
    //幻灯片切换时触发 num=幻灯片的索引
    oncarChange(pageNum){
      this.pageNum = pageNum;
      this.$emit("on-carchange",pageNum);
      if(Number(this.total) > Number(this.paginationSize)){
        //总条数大于页面条数，当索引切换到倒数第2个开始加载下一页
        //0 1 2 3 4 5 6 7 8
        let nn = Number(this.paginationSize) / 4;
        console.log('pageNum===',this.pageNum)
        console.log('索引===',Number(this.pageNum) % nn)
        if((Number(this.pageNum) % nn) == (nn-2)){
          //要判断幻灯片是前进还是后退，不能一直累加也要减1
          if(this.pageTnum < pageNum){
            //表示前进
            this.pageTwo+=1;
            console.log('pageTwo================1',this.pageTwo)
            //后退后又前进，之前已经走过的分页不要再请求，会造成数据重复
            if(!this.pageTwoList.includes(this.pageTwo)){
              this.pageTwoList.push(this.pageTwo);
              this.handleCurrentChange(this.pageTwo)
            }
            this.pageTnum = pageNum;
          }else if(this.pageTwo > 1){
            //后退不需要请求分页
            //this.pageTwo-=1;
            console.log('pageTwo================2',this.pageTwo)
          }
        }
      }
    },
    // 表头拖拽改变宽度事件
    headerDragend() {
      this.$refs.table.doLayout();
    },
    // 切换表格九宫格
    toggleFunc(ninetoggle){
      if(ninetoggle){
        this.ninetoggle = false;
        this.onnineselect(false)
      }else{
        this.ninetoggle = true;
      }
      this.togoData = [];
      if (this.showTableToggle) {
        this.showTableToggle(this);
      }
    },
    load() {
      this.togloading = true;
      this.page += 1;
      this.getList();
    },
    /***********************************************************审批部分函数开始**********************************************************************/
    // 根据id查找对应审批数据
    getWorkfllowData() {
      return new Promise(resp => {
        let query = {
          querys: [
            {
              hasInitValue: false,
              operation: "EQUAL",
              property: "id",
              relation: "AND",
              value: this.$route.params.busId
            }
          ]
        };
        axios(
          Object.assign(
            {},
            this.bQuery,
            { hostUrl: this.zuul },
            { data: query }
          )
        )
          .then(res => {
            resp(res.data.rows[0]);
          })
          .catch(err => {
            this.$message.error(err.message);
          });
      });
    },
    goWorkflow(data) {
      // if(this.$route.meta.busId){
      const _this = this;
      setTimeout(() => {
        if (_this.beforeWorkflow) {
          _this.beforeWorkflow(data).then(res => {
            // 获取当前行数据
            _this.getWorkfllowData().then(result => {
              // _this.saverow = data.filter(
              //   (x) => x.id == _this.$route.params.busId
              // )[0];
              _this.saverow = result;
              _this.workFlowClientshow = true;
              /**回显表单数据 */
              _this.$nextTick(() => {
                /**原本的表格双击事件 */
                _this.$refs.wfc.dataTableBrowdblclick(
                  _this.saverow,
                  this.workflowPram
                );
              });
            });
          });
        } else {
          // 获取当前行数据
          _this.getWorkfllowData().then(list => {
            // _this.saverow = data.filter(
            //   (x) => x.id == _this.$route.params.busId
            // )[0];
            _this.saverow = list;
            _this.workFlowClientshow = true;
            /**回显表单数据 */
            _this.$nextTick(() => {
              /**原本的表格双击事件 */
              _this.$refs.wfc.dataTableBrowdblclick(
                _this.saverow,
                this.workflowPram
              );
            });
          });
        }
      });
      // }
    },
    /**
     *描述：审批返回回调函数
     *版本：1.0
     */
    workflowGoback() {
      if (this.workflowBackFunc) {
        this.workflowBackFunc().then(res => {
          this.workFlowClientshow = false;
        });
      } else {
        this.workFlowClientshow = false;
      }
      this.$refs.table.doLayout();
    },
    /**
     *描述：待办表格加载完成后调用
     *版本：1.0
     */
    loadend(row) {
      let _this = this;
      /* 待办表格没哟任务时，下边的表单组件为空 */
      this.$refs.wfc.agencyCount == 0 && (this.$refs.wfc.row.route = "");
      /**刷新表单 */
      this.keyindex++;
      /**表单数据回显 */
      let obj = !this.$tu.isObjectBlank(row) ? row : this.saverow;
      // setTimeout(() => {
      //   /**回显表单数据，拖拽生成的表单 */
      //   _this.$refs.workflowdynamic.$children[0].$refs.generateForm &&
      //     _this.$refs.workflowdynamic.$children[0].$refs.generateForm.updateModels &&
      //       _this.$refs.workflowdynamic.$children[0].$refs.generateForm.updateModels(obj);
      //       /**回显表单数据，自己写的组件 */
      //   _this.$refs.workflowdynamic.$children[0].edit &&
      //     _this.$refs.workflowdynamic.$children[0].edit(obj);
      // },800);
    },

    /**
     *描述：审批
     *版本：1.0
     */
    onDefaultworkflow(cab, row) {
      if (this.newWorkflow) {
        // 新的逻辑
        let data = JSON.parse(JSON.stringify(row));
        // 新的逻辑
        if (this.beforeWorkflow) {
          this.beforeWorkflow(row).then(res => {
            this.$router.push({
              name: "workflowPage",
              loadPath: "workflowPage",
              chinesename: "审批详情",
              query: {
                list: data,
                processKey: this.processKey,
                workflowPram: res,
                processInstanceId: data.applyId
              }
            });
          });
          cab && cab();
          return;
        }
        this.$router.push({
          name: "workflowPage",
          loadPath: "workflowPage",
          chinesename: "审批详情",
          query: {
            list: data,
            processKey: this.processKey,
            workflowPram: this.workflowPram,
            processInstanceId: data.applyId
          }
        });
      } else {
        let _this = this;
        if (this.beforeWorkflow) {
          this.beforeWorkflow(row).then(res => {
            this.saverow = row;
            this.workFlowClientshow = true;
            // 回显表单数据
            setTimeout(() => {
              // 原本的表格双击事件
              this.$refs.wfc.dataTableBrowdblclick(row, this.workflowPram);
            });
          });
        } else {
          this.saverow = row;
          this.workFlowClientshow = true;
          // 回显表单数据
          setTimeout(() => {
            // 原本的表格双击事件
            _this.$refs.wfc.dataTableBrowdblclick(row, this.workflowPram);
          });
        }
      }
      cab && cab();
    },
    /***********************************************************审批部分函数结束**********************************************************************/
    /**
     *描述：表格全选事件
     *版本：1.0
     */
    onSelectAll(selection) {
      this.$emit("select-all", selection);
      this.isMulitype && this.$refs.table.clearSelection();
    },
    onSelect(selection, row) {
      this.$emit("select", selection, row);
    },
    // 获取表格实体类名字
    showTable() {
      this.$message.info(
        "实体类：" + this.tableName + " " + "页面名字：" + this.pageName
      );
    },
    //处理查询条件
    getQuery(findWhere) {
      let query = {};
      // if (!this.bQuery.hostUrl || !this.bQuery.url) {
      //   console.warn("服务器网址为空，不能发送请求");
      //   return query;
      // }
      let tQuery;
      if (!findWhere || this.$tu.isObjectBlank(findWhere)) {
        let searchForm = this.searchTitledialogVisible
          ? this.$refs.searchDialogForm
          : this.$refs.searchForm;
        let formQuery = searchForm ? searchForm.getFormValue() : {};
        //  Object.assign IE不支持, 所以后面Object.keys的保守其实是没有必要的。。。
        tQuery = Object.assign(
          {},
          formQuery,
          this.customQuery,
          this.sizeChangeQuery
        );
      } else {
        tQuery = Object.assign(
          {},
          findWhere,
          this.customQuery,
          this.sizeChangeQuery
        );
      }
      let size = this.hasPagination ? this.size : this.noPaginationSize;
      // 根据偏移值计算接口正确的页数
      let pageOffset = this.firstPath - defaultFirstPage;
      let page = this.page + pageOffset;
      let querys = [];
      let data, Ndata;
      for (let key in tQuery) {
        if (
          tQuery[key].hasOwnProperty("gx" + key) &&
          tQuery[key].hasOwnProperty("field" + key) &&
          tQuery[key].hasOwnProperty("value" + key)
        ) {
          let tmpValue = tQuery[key]["value" + key];
          if (tQuery[key]["andor" + key]) {
            if (tQuery[key]["group" + key]) {
              data = {
                hasInitValue: false,
                operation: tQuery[key]["gx" + key],
                property: tQuery[key]["field" + key],
                relation: tQuery[key]["andor" + key],
                value: tmpValue ? 1 : 0,
                group: tQuery[key]["group" + key]
              };
              Ndata = {
                hasInitValue: false,
                operation: tQuery[key]["gx" + key],
                property: tQuery[key]["field" + key],
                relation: tQuery[key]["andor" + key],
                value: tmpValue,
                group: tQuery[key]["group" + key]
              };
            } else {
              data = {
                hasInitValue: false,
                operation: tQuery[key]["gx" + key],
                property: tQuery[key]["field" + key],
                relation: tQuery[key]["andor" + key],
                value: tmpValue ? 1 : 0
              };
              Ndata = {
                hasInitValue: false,
                operation: tQuery[key]["gx" + key],
                property: tQuery[key]["field" + key],
                relation: tQuery[key]["andor" + key],
                value: tmpValue
              };
            }
          } else {
            data = {
              hasInitValue: false,
              operation: tQuery[key]["gx" + key],
              property: tQuery[key]["field" + key],
              relation: "AND",
              value: tmpValue ? 1 : 0
            };
            Ndata = {
              hasInitValue: false,
              operation: tQuery[key]["gx" + key],
              property: tQuery[key]["field" + key],
              relation: "AND",
              value: tmpValue
            };
          }
          if (typeof tmpValue === "boolean") {
            querys.push(data);
          } else if (typeof tmpValue === "number") {
            querys.push(Ndata);
          } else if (typeof tmpValue === "string") {
            if (tmpValue.length > 0) {
              querys.push(Ndata);
            }
          } else if (typeof tmpValue === "object") {
            querys.push(Ndata);
          }
        }
      }
      query = {
        pageBean: {
          page: page,
          pageSize: size,
          showTotal: true,
          summary: this.summary
        },
        params: {},
        querys: querys,
        selfDate: this.selfDate,
        sorter: this.xyjSorter
      };
      return query;
    },
    /**
     *描述：true：空条件查询，false:空条件不查询
     *版本：1.0
     */
    setNotCondition(value) {
      this.notCondition = value;
    },
    /**
     *描述：抛出查询方法
     *版本：1.0
     */
    getquery() {
      return this.querydata;
    },
    /**
     *描述：查询方法
     *版本：1.0
     */
    getList(findWhere, countFlag) {
      this.$refs.table && this.$refs.table.doLayout();
      if (this.codeVaule) {
        this.codeVaule(this);
      }
      let query = this.getQuery(findWhere);
      if (!this.notCondition && query.querys.length <= 0) {
        return;
      }
      this.querydata = query.querys;
      query.countFlag = countFlag ? true : false;
      query.dataAuthority = this.dataAuthority;
      //请求开始
      this.loading = true;
      function transformLOWtoUP (objs){
        var obj = {};
        for (var key in objs){
          obj[key.toUpperCase()] = objs[key];
        }
        return obj;
      }
      axios(
        Object.assign({}, this.bQuery, { hostUrl: this.zuul }, { data: query })
      )
        .then(res => {
          if (!res.data) {
            // 只查询合计
            if (countFlag) {
              this.summaryData = res.map ? transformLOWtoUP(res.map) : {};
              return;
            }
            this.data = res.data.rows;
            if (this.data[0]) {
              if (!this.data[0].id) {
                !this.data[0].id &&
                typeof this.data[0].id != "undefined" &&
                this.data[0].id != 0
                  ? (this.data[0].isShow = true)
                  : "";
              }
            }
            //2024-02-28 四宫格数据整理
            if(this.isSigongGrid){
              // this.newData = [];
              
              const chunkSize = 4;
              for (let i = 0; i < this.data.length; i += chunkSize) {
                this.newData.push(this.data.slice(i, i + chunkSize));
              }
              console.log('newData',this.newData)
              // let total =
              // typeof res.total === "string" ? Number(res.total) : res.total;
              // this.total = Math.ceil(total / 4);
              // this.summaryData = transformLOWtoUP(res.map);
              // if (this.newData.length > 0) {
              //   this.setCurrentRow(this.newData[0]);
              // }
            }
            this.total =
              typeof res.total === "string" ? Number(res.total) : res.total;
              this.summaryData = transformLOWtoUP(res.map);
              if (this.data.length > 0) {
                this.setCurrentRow(this.data[0]);
              }

          } else {
            // 只查询合计
            if (countFlag) {
              this.summaryData = res.data.map ? transformLOWtoUP(res.data.map) : {};
              return;
            }
            this.data = res.data.rows;
            //2024-02-28 四宫格数据整理
            if(this.isSigongGrid){
              // this.newData = [];
              const chunkSize = 4;
              for (let i = 0; i < this.data.length; i += chunkSize) {
                this.newData.push(this.data.slice(i, i + chunkSize));
              }
              console.log('newData==2',this.newData)
              // let total =
              // typeof res.data.total === "string"
              //   ? Number(res.data.total)
              //   : res.data.total;
              // this.total = Math.ceil(total / 4);
              // this.summaryData = transformLOWtoUP(res.data.map);
              // if (this.newData.length > 0) {
              //   this.setCurrentRow(this.newData[0]);
              // }
            }
            this.total =
              typeof res.data.total === "string"
                ? Number(res.data.total)
                : res.data.total;
              this.summaryData = transformLOWtoUP(res.data.map);
              if (this.data.length > 0) {
                this.setCurrentRow(this.data[0]);
              }

          }
          if (this.isTree) {
            this.data = this.tree2Array(this.data, this.expandAll);
          }
          this.$nextTick(() => {
            this.$refs.table && this.$refs.table.doLayout();
          });
          /**
           * 请求返回, 数据更新后触发, 返回(data, resp) data是渲染table的 数据, resp是请求返回的完整response
           * @event update
           */
          this.$emit("update", this.data, res,this.tableHeadList);
          // 自定义样式数据
          this.togoData =
            this.data.length > 0 ? this.togoData.concat(this.data) : [];
          this.togloading = false;
          if (
            this.$route.params.busId &&
            this.$route.meta.processKey == this.tableprocessKey
          ) {
            this.goWorkflow(this.data);
          }
        })
        .catch(err => {
          this.$message.error(err.message);
          this.$emit("error", err);
        })
        .finally(err => {
          this.loading = false;
        });
    },
    accountEnter(event) {
      if (event.keyCode == 13) {
        this.search();
      }
    },
    search() {
      this.$refs.searchForm.validate(valid => {
        if (!valid) return;
        this.beforeSearch()
          .then(() => {
            this.page = defaultFirstPage;
            // 清空切换样式的数据
            this.togoData = [];
            this.getList();
          })
          .catch(err => {
            this.$emit("error", err);
          });
      });
    },
    resetSearch() {
      // reset后, form里的值会变成 undefined, 在下一次查询会赋值给query
      this.$refs.searchForm.resetFields();
      this.page = defaultFirstPage;
      //重置
      history.replaceState(
        history.state,
        "",
        location.href.replace(queryPattern, "")
      );
      this.$nextTick(() => {
        this.getList();
      });
      this.$emit("reset");
      this.$emit(
        "update:customQuery",
        Object.assign(this.customQuery, JSON.parse(this.initCustomQuery))
      );
    },
    //高级查询重置
    seniorResetSearch() {
      // reset后, form里的值会变成 undefined, 在下一次查询会赋值给query
      this.$refs.searchDialogForm.resetFields();
      this.page = defaultFirstPage;
      //重置
      history.replaceState(
        history.state,
        "",
        location.href.replace(queryPattern, "")
      );
      this.$nextTick(() => {
        // 清空切换样式的数据
        this.togoData = [];
        this.getList();
      });
      this.$emit("reset");
      this.$emit(
        "update:customQuery",
        Object.assign(this.customQuery, JSON.parse(this.initCustomQuery))
      );
    },
    //高级查询查询
    seniorSearch() {
      this.$refs.searchDialogForm.validate(valid => {
        if (!valid) return;
        this.beforeSearch()
          .then(() => {
            this.page = defaultFirstPage;
            // 清空切换样式的数据
            this.togoData = [];
            this.getList();
          })
          .catch(err => {
            this.$emit("error", err);
          });
      });
    },
    handleSizeChange(val) {
      if (this.size === val) return;
      this.page = defaultFirstPage;
      this.size = val;
      if (this.searchMessage) {
        this.getList(this.searchMessage);
      } else {
        this.getList();
      }
    },
    handleCurrentChange(val) {
      console.log('分页================',val)
      if (this.page === val) return;
      this.page = val;
      this.getList();
    },
    handleSelectionChange(val, oldCurrentRow) {
      //如果是单选则进入
      if (!this.mSelect) {
        this.selected.length = 0;
        this.selected.push(val);
        this.$emit("selection-change", this.selected);
      }
    },
    RowClick(val, column, event) {
      this.$emit("row-click", val, column, event);
    },
    RowDblclick(val, column, event){
      this.$emit("row-dblclick", val, column, event);
    },
    //封装标题
    fxitem(item){
      let label = item.label;
      if(item.ifEntryRequired == 1){
        if(item.label.indexOf('*') == -1){
          item.label ='*' + label;
        }
      }
      return item
    },
    //表格可输入编辑,获取焦点时触发
    ToOperedit(val,row,item,index){
      // console.log('ToOperedit1',val)
      if(val == ''){
        this.onpeid = row.id;
        this.onpeprop = item.prop;
      }
      this.longText = val;
      this.longId = row.id;
      this.longProp = item.prop;
      this.longRow = row;
      this.longIndex = index;
      this.longifEntryRequired = item.ifEntryRequired;
      // console.log('================index',index)
    },
    //表格弹窗取消时间
    cancelConc(){
      this.choiceShow = false;
      this.isred = false;
    },
    //表格编辑弹窗确定事件
    dialogConc(){
      if(this.longifEntryRequired == 1 && (this.longText == '' || this.longText == null || this.longText == 'undefined')){
        this.$message({ type: "warning", message: '当前字段为必填字段，不能为空，否则将无法保存' });
        this.isred = true;
        return;
      }
      this.choiceShow = false;
      this.isred = false;
      
      // console.log('this.longText==1',this.longText)
      this.longRow[this.longProp] = this.longText;
      this.$set(
        this.$refs.table.data,
        this.longIndex,
        this.longRow
      );
      this.$emit("to-operedit", this.longText,this.longId,this.longProp,this.longifEntryRequired);
    },
    //时间选择器选中事件，下拉框选择器选中触发
    tochange(val){
      // console.log('tochange',val);
      this.onpeid = '';
      this.onpeprop = '';
      this.longText = val;
      this.$emit("to-operedit", this.longText,this.longId,this.longProp,this.longifEntryRequired);
    },
    toopere2dit(longText,longId,longProp,longifEntryRequired){
      this.$emit("to-operedit", longText,longId,longProp,longifEntryRequired);
    },
    //表格编辑失去焦点 文本格式
    onblur(val){
      // console.log('onblur---------',val);
      // if(val.originalTarget) this.longText = val.originalTarget.value
      this.longText = val
      // console.log('this.longText==2',this.longText)
      if(this.longifEntryRequired == 1 && (this.longText == '' || this.longText == null || this.longText == 'undefined')){
        this.$message({ type: "warning", message: '当前字段为必填字段，不能为空，否则将无法保存!' });
        this.isred = true;
        return;
      }
      this.isred = false;
      this.onpeid = '';
      this.onpeprop = '';
      this.$emit("to-operedit", this.longText,this.longId,this.longProp,this.longifEntryRequired);
    },
    //确认点击表格位置,通过点击定位到哪条数据的哪个字段 ctype = 1 点击表格  =2点击文字
    OnOperedit(row,item,ctype,index){
      // console.log('OnOperedit----row',row)
      // console.log('OnOperedit----item',item);
      // console.log('item.isEdit',item.isEdit);
      // console.log('notDdit',this.notDdit);
      // console.log('OnOperedit----index',index)
      if(this.isred){
        this.$message({ type: "warning", message: '请完善必填字段！' });
        return
      }
      this.longRow = row;
      this.longIndex = index;
      this.isred = false;
      let iseditfill = false;//是否禁止编辑该行数据
      for(var j = 0;j < this.notDdit.length;j++){
          // console.log('222====',this.notDdit[j].value.indexOf(row[this.notDdit[j].name]))
          if(this.notDdit[j].value.indexOf(row[this.notDdit[j].name]) != '-1'){
            iseditfill = true;
          }
      }
      // console.log('iseditfill',iseditfill)
      if(item.isEdit == '1' && !iseditfill){
        this.onpeid = row.id;
        this.onpeprop = item.prop;
        setTimeout(() => {
          var my = document.getElementById(row.id + item.prop);
          my.focus();
        },100)
        if(ctype == 1){
          // console.log('点击表格')
        }else{
          // console.log('点击文字')
          // this.onpeid = '';
          // this.onpeprop = '';
          //时间选择器不放大date日期  singleDate日期时间 datePicker日期范围 年月month
          if(item.fieldType != 'date' && item.fieldType != 'singleDate' && item.fieldType != 'datePicker' && item.fieldType != 'month' && item.fieldType != 'select'){
              //表格输入框放大
              this.textTitle = item.label;
              this.longText = row[item.prop];
              this.longifEntryRequired = item.ifEntryRequired;
              this.choiceShow = true;
          }
        }
      }
    },
    //下拉框数据整合
    numTapo(item){
          return Object.keys(JSON.parse(item.formatType)).map(
            fmt => {
              let obj = {};
              obj.label = JSON.parse(item.formatType)[fmt];
              obj.value = fmt;
              return obj;
            }
          );
    },
    mhandleSelectionChange(val) {
      //如果是否选则处理
      if (this.mSelect) {
        // 单选状态
        if (this.isMulitype) {
          if (val.length > 1) {
            var newRows = val.filter((it, index) => {
              if (index == val.length - 1) {
                this.$refs.table.toggleRowSelection(it, true);
                return true;
              } else {
                this.$refs.table.toggleRowSelection(it, false);
                return false;
              }
            });
            this.multipleSelection = newRows;
          } else {
            this.multipleSelection = val;
          }
        } else {
          this.selected = val;
          this.hasSelect = val.length > 1 ? true : false;
          /**
           * 多选启用时生效, 返回(selected)已选中行的数组
           * @event selection-change
           */
          this.$emit("selection-change", val);
        }
      }
    },
    /**
     *描述：选择一行数据
     *版本：1.0
     */
    setCurrentRow(data) {
      this.selected.length = 0;
      this.selected.push(data);
      this.$refs.table && this.$refs.table.setCurrentRow(data);
      this.$emit("selection-change", this.selected);
      // console.log('this.total',this.total)
      this.$emit("num-total", this.total);//2023-08-08 返回总条数
    },
    //表格数据导出
    onDefaultExport(cab) {
      let then = this;
      //得到查询条件
      let data = then.getQuery();
      let tmpExport = Object.assign({}, then.bExport);
      /**
       *描述：导出网址默认值处理
       *版本：1.0
       */
      if (then.$tu.isBlank(tmpExport.url)) {
        tmpExport.url = then.hostUrl + then.bQuery.url;
        tmpExport.hostUrl = then.hostUrl;
        tmpExport.pageName = then.pageName;
        tmpExport.projectCode = then.projectCode;
        tmpExport.userId = sessionStorage.getItem("userid");
        tmpExport.beanName = then.tableName;
        if (then.$tu.isBlank(tmpExport.url)) {
          then.$message.error("导出数据网址不能为空");
          cab();
          return;
        }
      }
      /**
       *描述：查询表名默认值处理
       *版本：1.0
       */
      if (then.$tu.isBlank(tmpExport.tableName)) {
        tmpExport.tableName = then.tableName;
        if (then.$tu.isBlank(tmpExport.tableName)) {
          then.$message.error("数据表名不能为空.");
          cab();
          return;
        }
      }
      data["selfDate"] = Object.assign({}, this.selfDate, tmpExport);
      /**
       *描述：调用接口导出数据
       *版本：1.0
       */
      then.$api.common
        .newExportExcel({ data })
        .then(res => {
          //处理下载文件
          then.$tu.downloadfile(res);
          cab();
        })
        .catch(err => {
          then.$message.error(err.message);
          cab();
        });
    },
    // 弹窗相关
    // 除非树形结构在操作列点击新增, 否则 row 都是 undefined
    onDefaultNew(cab, row = {}) {
      this.row = row;
      this.buttonState = true;
      this.isNew = true;
      this.isEdit = false;
      this.isView = false;
      this.dialogTitle = this.dialogNewTitle;
      this.dialogVisible = true;
      if (this.onBeforeNew) {
        this.onBeforeNew();
      }
      // 如果有默认数据，填充进表单
      if (this.onDialogDefault) {
        this.onDialogDefault(row);
        // 给表单填充值
        this.$nextTick(() => {
          this.$refs[dialogForm].updateForm(row);
        });
      }
      cab();
    },
    onDefaultView(cb, row) {
      this.row = row;
      this.buttonState = false;
      this.isView = true;
      this.isNew = false;
      this.isEdit = false;
      this.dialogTitle = row[this.objname]
        ? '查看"' + row[this.objname] + '"'
        : this.dialogViewTitle;
      this.dialogVisible = true;
      // 如果有默认数据，填充进表单
      if (this.onDialogDefault) {
        this.onDialogDefault(row, true);
        // 给表单填充值
        this.$nextTick(() => {
          this.$refs[dialogForm].updateForm(row);
        });
      }
      cb();
    },
    onDefaultDisabled(cb, row) {
      let data = {};
      // data[this.ifDisabled] = row[this.ifDisabled]
      data.id = row.id;
      axios(
        Object.assign(
          {},
          this.bDisabled,
          { params: data },
          { hostUrl: this.hostUrl }
        )
      )
        .then(res => {
          this.getList();
        })
        .catch(err => {
          this.$message.error(err.message);
        });
      cb();
    },
    onDefaultEdit(cab, row) {
      this.row = Object.assign({}, row);
      this.buttonState = true;
      this.isEdit = true;
      this.isNew = false;
      this.isView = false;
      this.dialogTitle = row[this.objname]
        ? '编辑"' + row[this.objname] + '"'
        : this.dialogEditTitle;
      this.dialogVisible = true;
      if (this.onBeforeEdit) {
        this.onBeforeEdit(row);
      }
      if (this.onDialogDefault) {
        this.onDialogDefault(this.row);
      }
      if (this.row.relationGroups) {
        this.row.relationGroups = JSON.parse(this.row.relationGroups);
      }
      cab();
    },
    // 弹框完全打开后事件
    openFunc() {
      // 更新表单数据
      if (this.dialogVisible) {
        this.$refs.dynamic.$refs.generateForm.updateModels &&
          this.$refs.dynamic.$refs.generateForm.updateModels(this.row);
        if (this.$refs.dynamic.$children[0].$refs.dynamic) {
          setTimeout(() => {
            this.$refs.dynamic.$children[0].$refs.dynamic.forEach(dyna => {
              dyna.selfComp.updateModels &&
                dyna.selfComp.updateModels(this.row);
            });
          }, 800);
        }
      }
    },
    /**
     *描述：编辑对话框关闭事件
     *版本：1.0
     */
    onCloseEdit() {
      // this.$refs.dialogForm.resetFields();
      this.$refs.dynamic.$refs.generateForm.updateModels &&
        this.$refs.dynamic.$refs.generateForm.updateModels();
      if (this.onEditDialogClose) {
        this.onEditDialogClose(this.row);
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.$refs.dynamic.$refs.generateForm.updateModels &&
        this.$refs.dynamic.$refs.generateForm.updateModels();
    },
    sure(isWorkflowFunc) {
      if (this.isView) {
        this.cancel();
        return;
      }
      let tdata = {};
      // 拖拽的表单中带有自己写的组件
      if (
        this.$refs.dynamic.$children[0].$refs.dynamic &&
        this.$refs.dynamic.$refs.generateForm.getData
      ) {
        this.$refs.dynamic.$children[0].$refs.dynamic.forEach(dyna => {
          if (dyna.selfComp.getData) {
            Promise.all([
              dyna.selfComp.getData(),
              this.$refs.dynamic.$refs.generateForm.getData()
            ]).then(result => {
              result.forEach(_result => {
                tdata = Object.assign(tdata, _result);
              });
              this.saveFunc(tdata, isWorkflowFunc);
              console.log("既有自己写的又有拖拽的", tdata);
            });
          } else {
          }
        });
      } else if (this.$refs.dynamic.$children[0].$refs.dynamic) {
        this.$refs.dynamic.$children[0].$refs.dynamic.forEach(dyna => {
          dyna.selfComp
            .getData()
            .then(respon => {
              tdata = Object.assign(tdata, respon);
              this.saveFunc(tdata, isWorkflowFunc);
              console.log("只有自己写的", tdata);
            })
            .catch(error => {});
        });
      } else if (this.$refs.dynamic.$refs.generateForm.getData) {
        this.$refs.dynamic.$refs.generateForm
          .getData()
          .then(res => {
            tdata = Object.assign(tdata, res);
            console.log("只有拖拽的", tdata);
            this.saveFunc(tdata, isWorkflowFunc);
          })
          .catch(err => {});
      }
    },
    saveFunc(tdata, isWorkflowFunc) {
      if (this.isTree) {
        this.isNew &&
          (tdata[this.treeParentKey] = this.row[this.treeParentValue]);
        !this.isNew &&
          (tdata[this.treeParentKey] = this.row[this.treeParentKey]);
      }
      let data = changeBoolean(tdata);
      this.beforeConfirm(data, this.isNew)
        .then(resp => {
          this.confirmLoading = true;
          let condiction = "isNew";
          let customMethod = "onNew";
          if (this.isEdit) {
            condiction = "isEdit";
            customMethod = "onEdit";
          }
          //外部处理钩子
          if (this[condiction] && this[customMethod]) {
            this[customMethod](data, this.row)
              .then(res => {
                // 新增成功后是否刷新表格
                if (this.isRefresh) {
                  this.getList();
                } else {
                  this.data.push(res.data);
                  // 是否刷新合计行
                  if (this.countFlag) {
                    this.getList(null, this.countFlag);
                  }
                }

                res.clear &&
                  this.$refs.dynamic.$refs.generateForm.updateModels();

                res.close && this.cancel();

                this.showMessage(true, res.successMessage);
                //onNew事件执行成功之后的回调方法 
                if (this.onAfterSuccessNew && this.isNew) {
                  this.onAfterSuccessNew(data, this.row);
                }
                /**
                 *描述：编辑事件成功之后的回调方法
                 *版本：1.0
                 */
                if (this.onAfterSuccessEdit && this.isEdit) {
                  this.onAfterSuccessEdit(data, this.row);
                }
                this.dialogVisible = false;
              })
              .catch(e => {
                this.showMessage(false, e.message);

                this.onAfterFailNew && this.onAfterFailNew(data, e.message);
              });
            this.confirmLoading = false;
            return;
          }
          // 默认新增/修改逻辑
          let url = Object.assign(
            {},
            this.isEdit ? this.bEditUrl : this.bNewUrl,
            { hostUrl: this.hostUrl }
          );
          if (url.url === "") {
            console.warn("没有填写接口地址，请核实");
            this.confirmLoading = false;
            return;
          }
          //外部处理上传数据
          if (this.isEdit) {
            this.onManualEdit && this.onManualEdit(data, this.row);
            data.id = this.row.id;
          } else if (this.isNew) {
            this.onManualNew && this.onManualNew(data);
          }
          if (!this.isRequest) {
            this.confirmLoading = false;
            return;
          }
          axios(Object.assign({}, url, { data: data }))
            .then(res => {
              //onNew事件执行成功之后的回调方法 
              if (this.onAfterSuccessNew && this.isNew) {
                this.onAfterSuccessNew(res.data, this.row);
              }
              /**
               *描述：编辑事件成功之后的回调方法
               *版本：1.0
               */
              if (this.onAfterSuccessEdit && this.isEdit) {
                this.onAfterSuccessEdit(res.data, this.row);
              }
              url.clear && this.$refs.dynamic.$refs.generateForm.updateModels();

              url.close && this.cancel();
              // 新增成功后是否刷新表格
              if (this.isRefresh) {
                this.getList();
              } else {
                this.data.push(res.data);
                // 是否刷新合计行
                if (this.countFlag) {
                  this.getList(null, this.countFlag);
                }
              }

              this.showMessage(true, this.isEdit ? "修改成功" : "新增成功");

              this.dialogVisible = false;

              this.confirmLoading = false;
              // 发起审批接口
              if (isWorkflowFunc == "isWorkflowFunc") {
                this.workFlowClientshow = true;
                setTimeout(() => {
                  this.$refs.wfc.startWorkFlow(
                    {
                      businessKey: res.data.id, //与工作流关联ID
                      variables: {} //工作流程执行时的流程变量
                    },
                    function(resultData) {
                      //成功回調
                      // rollback();
                    },
                    function(err) {
                      //失敗回調
                      this.$message.info(res.message);
                      // rollback();
                    }
                  );
                }, 800);
              }
            })
            .catch(err => {
              this.showMessage(false, err.message);
              if (this.onAfterFailNew && this.isNew) {
                this.onAfterFailNew(data, err.message);
              }
              if (this.onAfterFailEdit && this.isEdit) {
                this.onAfterFailEdit(data, err.message);
              }
              this.confirmLoading = false;
            });
        })
        .catch(err => {
          this.showMessage(false, err.message);
          if (this.onAfterFailNew) {
            this.onAfterFailNew(data, err.message);
          }
        });
    },
    onDefaultDelete(cab, row, state) {
      let then = this;
      this.$confirm(
        row[this.objname]
          ? '确定删除"' + row[this.objname] + '"这行数据吗'
          : "确定删除吗？",
        "提示",
        {
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action == "confirm") {
              let odata = [];
              if (state.toLowerCase() === "many") {
                for (let i = 0; i < then.selected.length; i++) {
                  odata.push(then.selected[i].id);
                }
              } else {
                odata.push(row.id);
              }
              instance.confirmButtonLoading = true;
              if (then.onDelete) {
                then
                  .onDelete(odata)
                  .then(resp => {
                    then.showMessage(true, "删除成功");
                    cab();
                    done();
                    then.getList();
                    //删除后成功事件
                    if (then.onAfterSuccessDelete) {
                      then.onAfterSuccessDelete(odata);
                    }
                  })
                  .catch(e => {
                    cab();
                    this.showMessage(true, e.message);
                    //删除后失败事件
                    if (this.onAfterFailDelete) {
                      this.onAfterFailDelete(odata, e.message);
                    }
                  })
                  .finally(e => {
                    cab();
                    instance.confirmButtonLoading = false;
                  });
                return;
              }
              //默认删除
              if (!then.bDeleteUrl.url) {
                this.$message.error("服务器网址为空，不能发送请求");
                instance.confirmButtonLoading = false;
                cab();
                return;
              }
              //外部处理上传数据
              if (this.onManualDelete) {
                this.onManualDelete(odata);
              }
              odata = odata.filter(item => item);
              axios(
                Object.assign(
                  {},
                  then.bDeleteUrl,
                  { data: odata },
                  { hostUrl: this.hostUrl }
                )
              )
                .then(res => {
                  done();
                  //删除后成功事件
                  if (then.onAfterSuccessDelete) {
                    then.onAfterSuccessDelete(odata);
                  }
                  then.getList();
                  then.showMessage(true, "删除成功");
                  instance.confirmButtonLoading = false;
                  cab();
                })
                .catch(err => {
                  //删除后失败事件
                  cab();
                  if (then.onAfterFailDelete) {
                    then.onAfterFailDelete(odata, err.message);
                  }
                  then.showMessage(false, err.message);
                  instance.confirmButtonLoading = false;
                });
            } else {
              done();
            }
            cab();
          }
        }
      ).catch(er => {
        /*取消*/
        cab();
      });
      cab();
    },
    onCustomButtonsClick(cb, fn, parameter, index) {
      if (!fn) return;
      fn(parameter, index)
        .then(flag => {
          if (flag === false) return;
          this.getList();
          cb();
        })
        .catch(e => {
          cb();
        })
        .finally(e => {
          cb();
        });
    },
    // 树形table相关
    tree2Array(data, expandAll, parent = null, level = null) {
      let tmp = [];
      data.forEach(record => {
        if (record._expanded === undefined) {
          this.$set(record, "_expanded", expandAll);
        }
        let _level = 0;
        if (level !== undefined && level !== null) {
          _level = level + 1;
        }
        this.$set(record, "_level", _level);
        // 如果有父元素
        if (parent) {
          this.$set(record, "parent", parent);
        }
        tmp.push(record);

        if (record[this.treeChildKey] && record[this.treeChildKey].length > 0) {
          const children = this.tree2Array(
            record[this.treeChildKey],
            expandAll,
            record,
            _level
          );
          tmp = tmp.concat(children);
        }
      });
      return tmp;
    },
    showRow(row) {
      const show = row.row.parent
        ? row.row.parent._expanded && row.row.parent._show
        : true;
      row.row._show = show;
      return show
        ? "animation:treeTableShow 1s-webkit-animation:treeTableShow 1s"
        : "display:none";
    },
    // 切换下级是否展开
    toggleExpanded(trIndex) {
      const record = this.data[trIndex];
      record._expanded = !record._expanded;
    },
    // 图标显示
    iconShow(index, record) {
      return record[this.treeChildKey] && record[this.treeChildKey].length > 0;
    },
    showMessage(isSuccess = true, message = "message没有传入提示信息") {
      if (isSuccess) {
        this.$message({
          type: "success",
          message: message
        });
      } else {
        this.$message({
          type: "error",
          message: message
        });
      }
    },
    //添加查询
    addHighFind() {
      let then = this;
      let tIndex = this.searchDataForm.length;
      //克隆数据
      // 字段下拉框
      let tmpFieldsDown = clone(fieldsDown);
      tmpFieldsDown.$id = "field" + tIndex;
      tmpFieldsDown.$groupid = tIndex + "";
      tmpFieldsDown.$default = "";
      tmpFieldsDown.$el.size = "small";
      Object.assign(tmpFieldsDown.$options, this.fieldSelectValue);

      tmpFieldsDown.atChange = function(id, value) {
        //根据类型改变输查询值的输入组件方式
        then.searchDataForm.some(cvalue => {
          if (cvalue.$id == this.$groupid) {
            then.searchItems[0].some(column => {
              if (column.prop) {
                if (
                  value.toLocaleLowerCase() === column.prop.toLocaleLowerCase()
                ) {
                  let tmpInputValue = clone(convertInput(column,then.ismonth));
                  tmpInputValue.$id = "value" + cvalue.$id;
                  tmpInputValue.rules = null;
                  tmpInputValue.label = "";
                  then.iniInput(tmpInputValue, column);
                  Object.assign(cvalue.$items[2], tmpInputValue);

                  // 关系符
                  /*let relationshipValue = clone(relationship);
                  let ary = JSON.parse(column.relationGroups);
                  relationshipValue.$options = relationshipValue.$options.filter(
                    (item) => ary.some((e) => e === item.type)
                  ).sort((a,b) => {
                    return ary.map(s => s).indexOf(a.type) < ary.map(s => s).indexOf(b.type) ? -1 : 1;
                  });
                  relationshipValue.$id = "gx" + cvalue.$id;
                  relationshipValue.$el.size = "small";
                  Object.assign(cvalue.$items[1], relationshipValue);
                  then.searchKey++ */
                  return true;
                }
              }
            });
            return true;
          }
        });
      };
      tmpFieldsDown.$options = tmpFieldsDown.$options.reverse();
      //关系符
      let tmpRelationship = clone(relationship);
      tmpRelationship.$id = "gx" + tIndex;
      tmpRelationship.$el.size = "small";

      //并且或者
      let tmpAndOr = clone(andOr);
      tmpAndOr.$id = "andor" + tIndex;
      tmpAndOr.$el.size = "small";

      //根据已存在的搜索条件增加新条件时判断使用何种关系符，出现两个以上相同搜索条件则默认使用或者
      // let listandOr = [];
      // this.searchDataForm.forEach((ite, i) => {
      //   listandOr.push(ite[i].$items[0].$default)
			// });
      // console.log('listandOr',listandOr)

      //查询值
      let inputWhere = clone(inputValue);
      inputWhere.$id = "value" + tIndex;
      inputWhere.rules = null;
      inputWhere.$groupid = tIndex + "";
      inputWhere.label = "";
      inputWhere.$el.size = "small";

      //删除按钮
      let deleteB = clone(deleteButton);
      deleteB.$id = "del" + tIndex;
      deleteB.$groupid = tIndex + "";
      deleteB.click = function(event) {
        let idx = -1;
        for (let j = 0; j < then.searchDataForm.length; j++) {
          if (then.searchDataForm[j].$id === this.$groupid) {
            idx = j;
            break;
          }
        }
        if (idx > -1) {
          then.searchDataForm.splice(idx, 1);
        }
      };

      this.searchDataForm.push({
        $id: tIndex + "",
        $type: "group",
        $quick: "0",
        $allTableColumns: this.allTableColumns,
        $items: [tmpFieldsDown, tmpRelationship, inputWhere, tmpAndOr, deleteB]
        // $items: [tmpFieldsDown, tmpRelationship, inputWhere, deleteB],
      });
    },
    searchOpen() {
      this.sValue = this.$refs.searchForm.getFormValue();
    },
    //选择数据暂存
    fInputSelect(prop, dicttype, value = []) {
      if (this.inputSelect[prop]) {
        return this.inputSelect[prop];
      } else {
        if (!this.zuul) {
          this.$message.error("服务器网址为空，不能发送请求");
          return;
        }
        let tmpUrl =
          this.zuul + "/xyj-admin/r/dict/findByType?type=" + dicttype;
        let token = sessionStorage.getItem('tkn');
        let then = this;
        jquery.ajax({
          headers: {
            token: token,
            "Content-Type": "application/json;charset=UTF-8"
          },
          url: tmpUrl,
          type: "GET", //GET
          async: false, //或false,是否异步
          data: {},
          timeout: 10000, //超时时间
          dataType: "json", //返回的数据格式：
          beforeSend: function(xhr) {},
          success: function(data, textStatus, jqXHR) {
            then.inputSelect[prop] = [];
            data.data.forEach((value, idx) => {
              then.inputSelect[prop].push({
                key: value.id,
                label: value.label,
                value: value.value,
                remarks: value.remarks ? value.remarks : ""
              });
            });
          },
          error: function(xhr, textStatus) {
            return [];
            console.error(textStatus);
          },
          complete: function() {}
        });
        return then.inputSelect[prop];
      }
    },
    //初始化
    iniInput(inputWhere, column) {
      if (
        inputWhere.$type === "select" ||
        inputWhere.$type === "radio-group" ||
        inputWhere.$type === "checkbox-group"
      ) {
        inputWhere.$options.length = 0;
        // 自定义的内容
        if (column.formatType && column.formatType != "null") {
          inputWhere.$options = Object.keys(JSON.parse(column.formatType)).map(
            fmt => {
              let obj = {};
              obj.label = JSON.parse(column.formatType)[fmt];
              obj.value = fmt;
              return obj;
            }
          );
        }
        // 不固定的内容，需要请求接口的
        if (this.extraSelectData[column.prop.toLocaleLowerCase()]) {
          if (this.inputSelect[column.prop.toLocaleLowerCase()]) {
            inputWhere.$options = inputWhere.$options.concat(
              this.inputSelect[column.prop.toLocaleLowerCase()]
            );
            return;
          }
          if (
            typeof this.extraSelectData[column.prop.toLocaleLowerCase()] ===
            "function"
          ) {
            let tmpdata = this.extraSelectData[column.prop.toLocaleLowerCase()](
              column
            );
            if (tmpdata) {
              inputWhere.$options = inputWhere.$options.concat(tmpdata);
              this.inputSelect[column.prop.toLocaleLowerCase()] = tmpdata;
            } else {
              console.warn("外部函数没有返回值");
            }
          }
        } else {
          //系统根据设置请求字典数据
          if (column.dicttype) {
            let tmpData = this.fInputSelect(
              column.prop.toLocaleLowerCase(),
              column.dicttype
            );
            inputWhere.$options = inputWhere.$options.concat(tmpData);
          }
        }
      }
    },
    //字段排序
    fieldSort(column) {
      this.xyjSorter.length = 0;
      if (column.prop) {
        let direc = column.order === "ascending" ? "ASC" : "DESC";
        this.xyjSorter.push({ direction: direc, property: column.prop });
      } else {
        this.xyjSorter = this.xyjSorter.concat(this.sorter);
      }
      let query = this.sizeChangeQuery;
      if (this.sortVaule) {
        query = this.sortVaule();
      }
      if (!this.isSelfSort) {
        this.getList(query);
      }
    },
    /*
     *@Date: 2021-11-04 16:47:04
     *@Description:获取当前选择数据
     *@params:
     */
    getSelected() {
      return this.selected;
    },
    getTableHead() {
      var then = this;
      let tIndex = -1;
      // let loadingInstance = this.$loading({
      //   text:"玩命初始化窗体"
      // });
      if (
        this.$route.path == "/Sys/WorkflowPage" ||
        this.$route.path == "/workflowPage"
      ) {
        // this.workflowShowOperation = false;//20230327
        if(this.isinquire){
          this.$set(then.customQuery, 99, {
            field99: "id",
            gx99: "EQUAL",
            value99: this.$route.meta.obj.list.businessId
              ? this.$route.meta.obj.list.businessId
              : this.$route.meta.obj.list.businessKey
              ? this.$route.meta.obj.list.businessKey
              : this.$route.meta.obj.list.id,
            andor99: "AND"
          });
        }
      }
      // 判断是否需要修改表头数据
      let data = {};
      data =
        Object.keys(this.editAxios).length == 0
          ? {
              hostUrl: this.zuul,
              url:
                "/xyj-admin/r/tPageTable/findTableInfo?pageName=" +
                this.pageName +
                "&projectCode=" +
                this.projectCode +
                "&userId=" +
                sessionStorage.getItem("userid") +
                "&beanName=" +
                this.tableName,
              method: "get"
            }
          : this.editAxios;
      //查询表格初始化数据
      axios(data)
        .then(res => {
          this.tableHeadList = res.data;
          this.processKey = res.data.processKey;
          this.tableprocessKey = res.data.processKey;
          if (this.tableColumns.length === 0) {
            let test = this.$XyjVueLoader(res.data.code1, res.data.beanName);
            Vue.component(res.data.beanName + Math.random(), test);
            this.comp = test;
            this.compKey++;
            this.objname = res.data.props[0];
            let tada = res.data.data;
            if(!this.showtips){
              for(var j in tada){
                tada[j].showOverflow = 0
              }
            }else{
              for(var j in tada){
                tada[j].showOverflow = 1
              }
            }
            console.log('tada=',tada)
            this.tableColumns = columnClone(tada);
            //处理外部字段格式化
            this.tableColumns.forEach((column, index) => {
              //设置是否有多选状态
              if (
                column.prop.toLowerCase() === "select" &&
                column.ifShow == 1
              ) {
                this.mSelect = true;
              }
              if (column.formatType && column.formatType != "null") {
                // 如果有格式化，判断是否有多级表头
                column.children && column.children.length > 0
                  ? column.children.forEach(data => {
                      data.formatType &&
                        (data.formatter = function(
                          row,
                          columns,
                          cellValue,
                          index
                        ) {
                          return Object.keys(
                            JSON.parse(data.formatType)
                          ).includes(cellValue.toString())
                            ? JSON.parse(data.formatType)[cellValue]
                            : cellValue;
                        });
                    })
                  : (column.formatter = function(
                      row,
                      columns,
                      cellValue,
                      index
                    ) {
                      if (cellValue || cellValue == 0) {
                        return Object.keys(
                          JSON.parse(column.formatType)
                        ).includes(cellValue.toString())
                          ? JSON.parse(column.formatType)[cellValue]
                          : cellValue;
                      }
                    });
              }
            });
          }
          //
          this.allTableColumns = ArrangementColumns(this.tableColumns);
          //字段选择下拉框数据
          this.allTableColumns.forEach((column, index) => {
            if (!column.label && !column.prop) return;
            if (column.type === "selection") return;
            //整理汇总条件
            if (column.sumType) {
              this.summary.push({
                fieldName: column.prop,
                type: column.sumType
              });
            }
          });
          //所搜
          this.searchItems = JSON.parse(JSON.stringify(res.data.searchItems));
          this.searchItems.forEach((column, index) => {
            tIndex = tIndex + 1;
            let tmpFieldsDown = clone(fieldsDown);
            let tmpRelationship;
            let inputWhere;
            column.reverse().forEach(_column => {
              this.fieldSelectValue.push({
                key: _column.prop,
                label: _column.label,
                value: _column.prop
              });
              // 字段下拉框
              tmpFieldsDown.$id = "field" + tIndex;
              tmpFieldsDown.$groupid = tIndex + "";
              tmpFieldsDown.$default = _column.prop;
              tmpFieldsDown.$el.size = "small";
              Object.assign(tmpFieldsDown.$options, this.fieldSelectValue);
              tmpFieldsDown.atChange = function(id, value) {
                //根据类型改变输查询值的输入组件方式
                then.searchDataForm.some(cvalue => {
                  if (cvalue.$id == this.$groupid) {
                    then.searchItems[0].some(_column => {
                      if (_column.prop && _column.prop != "children") {
                        if (
                          value.toLocaleLowerCase() ===
                          _column.prop.toLocaleLowerCase()
                        ) {
                          let tmpInputValue = clone(convertInput(_column,then.ismonth));
                          tmpInputValue.$id = "value" + cvalue.$id;
                          tmpInputValue.rules = null;
                          tmpInputValue.label = "";
                          then.iniInput(tmpInputValue, _column);
                          Object.assign(cvalue.$items[2], tmpInputValue);
                          // 关系符
                          let relationshipValue = clone(relationship);
                          let ary = JSON.parse(_column.relationGroups);
                          if (ary && ary.length > 0) {
                            relationshipValue.$options = relationshipValue.$options
                              .filter(item => ary.some(e => e === item.type))
                              .sort((a, b) => {
                                return ary.map(s => s).indexOf(a.type) <
                                  ary.map(s => s).indexOf(b.type)
                                  ? -1
                                  : 1;
                              });
                          } else {
                            relationshipValue.$options = [];
                          }
                          relationshipValue.$id = "gx" + cvalue.$id;
                          relationshipValue.$el.size = "small";
                          relationshipValue.$default =
                            relationshipValue.$options[0].value;
                          Object.assign(cvalue.$items[1], relationshipValue);
                          cvalue.$items[0].$default = _column.prop;
                          then.searchKey++;
                          return true;
                        }
                      }
                    });
                    return true;
                  }
                });
              };
              //关系符
              tmpRelationship = clone(relationship);
              if (_column.prop != "children") {
                let arr = JSON.parse(_column.relationGroups);
                if (arr && arr.length > 0) {
                  tmpRelationship.$options = tmpRelationship.$options
                    .filter(item => arr.some(e => e === item.type))
                    .sort((a, b) => {
                      return arr.map(s => s).indexOf(a.type) <
                        arr.map(s => s).indexOf(b.type)
                        ? -1
                        : 1;
                    });
                } else {
                  tmpRelationship.$options = [];
                }
              }
              tmpRelationship.$id = "gx" + tIndex;
              tmpRelationship.$el.size = "small";
              tmpRelationship.$default = tmpRelationship.$options[0]
                ? tmpRelationship.$options[0].value
                : "";

              //查询值
              inputWhere = convertInput(_column,then.ismonth);
              inputWhere.$id = "value" + tIndex;
              inputWhere.rules = null;
              inputWhere.$groupid = tIndex + "";
              inputWhere.label = "";
              this.iniInput(inputWhere, _column);
            });
            tmpFieldsDown.$options = tmpFieldsDown.$options.reverse();
            this.searchDataForm.push({
              $id: tIndex + "",
              $type: "group",
              $allTableColumns: this.allTableColumns,
              $items: [tmpFieldsDown, tmpRelationship, inputWhere]
            });
            this.getQuickSearchs.push({
              $id: tIndex + "",
              $type: "group",
              $allTableColumns: this.allTableColumns,
              $items: [tmpFieldsDown, tmpRelationship, inputWhere]
            });
          });
          this.$nextTick(() => {
            /**
             *描述：设置空条件查询开关变量，true:空条件查询，false:空条件不查询
             *版本：1.0
             */
            this.notCondition = this.bQuery.notCondition;
            this.getList(this.InitQuery);
          });
        })
        .catch(err => {
          console.error(err);
        })
        .finally(err => {
          // this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          //   loadingInstance.close();
          // });
        });
    },
    onshownine(index){
      //选择模式下不监听鼠标事件，避免程序加载浪费
      if(!this.isnineSelect){
        this.isshownine = true;
        this.nineindex = index;
      }
    },
    onhidenine(index){
      //选择模式下不监听鼠标事件，避免程序加载浪费
      if(!this.isnineSelect){
        this.isshownine = false
        this.nineindex = index;
      }
    },
    //是否九宫格选择模式 默认不能选择 即打开查看大图  true则表示选择
    onnine(row,index){
      if(this.isnineSelect){
        //多选模式下
        if(this.nineselect == -1){
          this.data.forEach((val, i) => {
            this.$set(val, "isSelect", false);
          });
        }
        // console.log('data----1',this.data)
        if(row.isSelect){
          row.isSelect = false;
          this.selectList = this.selectList.filter(item => {
            return item.id != row.id;
          });
        }else{
          if(this.isnineRadio){
            this.data.forEach((val, i) => {
              this.$set(val, "isSelect", false);
            });
            this.selectList = [row]
          }else{
            this.selectList.push(row);
          }
          row.isSelect = true;
        }
        this.nineselect = index;
        //选择模式下生效 true表示开启选择实时返回已选数据，此模式下没有确定按钮
        if(this.isnineEcho){
          this.$emit("on-nineecho",row);
        }
        //临时增加的实时返回已选数据，此模式不会禁用确认按钮
        if(this.isnine2Echo){
          this.$emit("on-nineecho",row);
        }
        // console.log('selectList----2',this.selectList)
      }
    },
    //操作选择状态 true 确认  false 取消
    onnineselect(isSele){
      this.$emit("on-nineselect",isSele,this.selectList);
      setTimeout(() => {
        this.selectList = [];
        this.data.forEach((val, i) => {
          this.$set(val, "isSelect", false);
        });
      }, 50);
    },
    //九宫格其它按钮触发 type  1=编辑 2=搜索图片 3=查看详情
    onothernine(type,row){
      if(type == 3){
        this.$emit("on-othernine",type,row);
      }else if(!this.isnineSelect){
        this.$emit("on-othernine",type,row);
      }
    },
    // 点击预览图标实现预览
    preShow(img, index) {
      this.nineImgKey++;
      // console.log('isnineSelect1',this.isnineSelect)
      if(!this.isnineSelect){
        this.preIndex = index;
        this.srcList = [img];
        setTimeout(() => {
          this.$refs.viewer.$viewer.view(this.preIndex);
          this.$refs.viewer.$viewer.show();
        }, 50);
      }
    },
    //时间处理
    handletime(time,ishandletime){
      if(time != null && time != ''){
        if(ishandletime){
          return time = time.replace(/-/g, "/").slice(0, 10);
        }else{
          return time
        }
      }
    }
  },
  computed: {
    noMore() {
      return this.togoData.length >= this.total;
    },
    scrolldisabled() {
      return true;
    },
    /**
     *  表格默认属性
     * */
    getTableAttrs() {
      let then = this;
      let tmp = {
        border: true,
        headerCellStyle: function({ row, column, rowIndex, columnIndex }) {
          then.tableColumns.forEach((x, i) => {
            if (x.label === column.label) {
              column.columncolor = x.columncolor;
            }
          });
          row.forEach(x => {
            if (x.children && x.children.length) {
              for (let i = 0, l = x.children.length; i < l; i++) {
                x.children[i].columncolor = x.columncolor;
                x.children[i].parentName = x.label;
              }
            }
          });
          if (column.label === "序号" || column.label === "操作")
            column.columncolor =
              row.length > 2 ? row[1].columncolor : "#FCFCFC";
          return "background-color:" + column.columncolor;
        },
        showSummary: true,
        summaryMethod: function(objData) {
          const tmpcolumns = objData.columns;
          let sums = [];
          tmpcolumns.forEach((column, index) => {
            if (column.property) {
              let fieldname = column.property.toUpperCase();
              let tmpValue = then.summaryData[fieldname];
              sums[index] = tmpValue ? tmpValue : "";
            }
          });
          return sums;
        }
      };
      return Object.assign(tmp, this.tableAttrs);
    },
    /**
     *  获取排序列
     * */
    getTableColumns() {
      return this.tableColumns.sort(function(a, b) {
        return a.arrange - b.arrange;
      });
    },
    /**
     *  获取快捷查询字段
     * */
    getQuickSearch() {
      let tmpQuick = this.getQuickSearchs.filter(function(column) {
        return true;
      });
      return tmpQuick.splice(0, 1);
    },
    getdialogFrom() {
      
      let then = this;
      let tmpWidth = 0;
      let tmpdialogFrom = this.dialogFrom.filter(function(column) {
        let labelLength =
          column.label.replace(/[\u0391-\uFFE5]/g, "aa").length / 2;
        if (tmpWidth < labelLength) {
          tmpWidth = labelLength;
        }
        if (then.buttonState) {
          if (column.$editshow === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      });
      then.xyjformAttrs.labelWidth = tmpWidth + 2 + "em";
      return tmpdialogFrom;
    },
    getImg() {
      let then = this;
      return then.image;
    }
  },
  created() {
    this.getTableHead();
    /**审批需要的routeId */
    if (this.$route.query.id) {
      localStorage.setItem("routeId", this.$route.query.id);
      this.routeId = localStorage.getItem("routeId");
    }
    if (localStorage.getItem("routeId")) {
      this.routeId = localStorage.getItem("routeId");
    }
  },
  mounted() {
    let _this = this;
    if(this.isSigongGrid){
       _this.containerWidth = this.$refs.carouselContainer.offsetWidth;
       _this.carouselWidth = this.$refs.carousel.$el.offsetWidth;
    }
    window.addEventListener("resize", function() {
      _this.$refs.table.doLayout();
    });
  },
  activated() {
    // 显示审批模块
    if (
      this.$route.params.busId &&
      this.$route.meta.processKey == this.tableprocessKey
    ) {
      this.goWorkflow(this.data);
    }
    this.$refs.table.doLayout();
  },
  beforeDestroy() {
    localStorage.removeItem("routeId");
  },
  
};
</script>

<style lang="scss">
.xyj-table {
  height: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.xyj-tooltip {
  padding: 0px;
  .el-form-item {
    margin-bottom: 0;
  }
}
#tabledrag {
  color-blue: #2196f3;
  space-width: 18px;

  .serachStyle {
    text-align: left;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-left: 20px;
    .el-form-item {
      margin-bottom: 0 !important;
      /*min-width: 282px;*/
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .el-form-item__content > div {
        max-width: 150px;
        input {
          max-width: 150px;
        }
      }
    }
    .el-select {
      width: 100% !important;
    }
    & > div:nth-of-type(n + 2) {
      margin-top: 8px;
    }
    & > div > div {
      display: flex;
      justify-content: flex-end;
      & > div {
        display: flex;
        align-items: center;
        label {
          white-space: nowrap;
          text-align: right;
        }
      }
      // & > div:nth-of-type(1) {
      //   width: 200px;
      // }
      // & > div:nth-of-type(2) {
      //   width: 185px;
      // }
    }
  }
  .senior-serach-style {
    text-align: left;
    .el-form-item {
      margin-bottom: 0 !important;
      //min-width: 282px;
      display: flex;
      align-items: center;
    }
    & > div > div {
      display: flex;
      //min-width: 750px;
      & > div {
        display: flex;
        align-items: center;
        label {
          white-space: nowrap;
        }
      }
      & > div:nth-last-of-type(1) > div {
        min-width: 40px !important;
      }
    }
  }
  // .el-dialog {
  //   width: auto;
  //   display: inline-block;
  //   form > div {
  //     display: block !important;
  //     margin-bottom: 15px;
  //     & > div {
  //       & > div:nth-last-of-type(1) .el-form-item__content {
  //         margin: 0 7px !important;
  //       }
  //       & > div .el-form-item__label {
  //         width: auto !important;
  //         display: inline-block;
  //         margin-left: 10px;
  //         //min-width: 62px;
  //       }
  //       & > div .el-form-item__content {
  //         margin: 0 !important;
  //       }
  //     }
  //   }
  //   .el-dialog__body {
  //     padding: 0px 2px;
  //   }
  // }
  .ms-tree-space {
    position: relative;
    top: 1px;
    display: inline-block;
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    width: 400px;
    height: 14px;

    &::before {
      content: "";
    }
  }

  .tree-ctrl {
    position: relative;
    cursor: pointer;
    color: #ff4500;
  }

  .getInvestInfo {
    text-align: left;
    margin-bottom: 10px;
  }

  @keyframes treeTableShow {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
}
.el-input .el-input__count .el-input__count-inner {
  background: transparent !important;
}
.newDialog .el-dialog__body {
  text-align: left;
}
.newDialog .el-dialog__body > form {
  padding-left: 0px;
  padding-right: 20px;
}
.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 2;
}
.yellow {
  background-color: #ffff93 !important;
}
#searchDialog {
  .senior-serach-style {
    text-align: left;
    & > div > div {
      display: flex;
    }
  }
  .el-dialog {
    width: auto;
    display: inline-block;
    form > div {
      display: block !important;
      & > div {
        & > div:nth-last-of-type(1) .el-form-item__content {
          margin: 0 7px !important;
        }
        & > div .el-form-item__label {
          width: auto !important;
          display: inline-block;
          margin-left: 10px;
        }
        & > div .el-form-item__content {
          margin: 0 !important;
          display: inline-block;
        }
      }
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}
i {
  margin: 0;
}
.avatar {
  width: 160px;
  height: 160px;
  display: block;
}
/deep/.el-table--border th.gutter:last-of-type {
  display: table-cell !important;
}

.el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
.el-table__body tr.current-row > td {
  background-color: rgba(0, 158, 250, 0.5) !important;
}
.inputDialog .el-dialog__body{
  padding: 0px 20px !important;
}
.inputDialog .el-dialog__footer{
  padding: 10px 20px !important;
}
.inputDialog .el-dialog__header{
  padding: 10px 20px !important;
}
.inputDialog .el-dialog__headerbtn{
  top:10px !important;
}
.inputDialog .el-form-item--mini.el-form-item,.inputDialog .el-form-item--small.el-form-item{
  margin-bottom: 0px!important;
}

.conc_nine1{
  width: 174px;
  height: 234px;
  border-radius: 15px;
  box-shadow: 1px 8px 10px #d2d2d2;
  float: left;
  margin-right: 5px;
  margin-bottom: 6px;
}
.conc_nine1_s1{
  border: 3px solid transparent;
}
.conc_nine1_s2{
  border: 3px solid #2196f3;
}
.conc_nine1_p1{
  height: 174px;
  width: 174px;
}
.conc_nine1_p1 img{
  height: 174px;
  width: 174px;
  border-radius: 15px 15px 0px 0px;
}
.conc_nine1_p1a{
  height: 30px;
  width: 158px;
  padding: 8px;
  background-image: linear-gradient(to top,#888888,rgba(255,0,0,0));
  position: absolute;
  display: flex;
  justify-content: end;
  align-items: flex-end;
}
.conc_nine1_p1as{
  height: 23px;
  width: 23px;
  line-height: 23px;
  text-align: center;
  background-color: #ffffff;
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  box-shadow: 0px 1px 5px #999;
}
.conc_nine1_p1b{
    width: 0;
    height: 0;
    border-top: 45px solid #f00;
    border-left: 45px solid transparent;
    position: absolute;
    border-radius: 0px 15px 0px 0px;
}
.conc_nine1_p2{
  height: 60px;
  width: 174px;
  padding: 5px 8px;
}
.conc_nine1_p2a{
  width: 158px;
  min-height: 22px;
}
.conc_nine1_p2as{
  color: #999;font-size: 14px;text-align: right;background: none;border: none;
}
.conc_nine1_p2as:hover{
  color: #2196f3;font-size: 14px;text-align: right;background: none;border: none;
}
.conc_nine1_p2ab{
  color: #86C50D;font-size: 12px;text-align: right;font-weight: bold;
}
.chao1-cc{
  text-overflow: -o-elipsis-lastline;
  overflow: hidden;
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.chao1-xx{
  text-overflow: -o-elipsis-lastline;
  overflow: hidden;
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.chao1-xx:hover{
  text-overflow: -o-elipsis-lastline;
  overflow: hidden;
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.chao2-cc{
  text-overflow: -o-elipsis-lastline;
  overflow: hidden;
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.clearfix-cc:after {
  content: '\20';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
  overflow: hidden;
}
.custom-carousel {
  overflow: hidden;
  position: relative;
}
.custom-carousel .el-carousel {
  transition: none;
}
</style>



// WEBPACK FOOTER //
// src/components/xyjtable/xyjtableDragNew.vue